import type { Dict } from '../types';
import { en } from './en';

export const uk: Dict = {
  ...en,
  'chat.amrCard.switchTitle': 'Не вдалося викликати модель — це виконання призупинено',
  'chat.amrCard.switchBody': 'Перейдіть на офіційний сервіс моделей AMR від Open Design — без налаштування API-ключа. Після входу, авторизації та поповнення це виконання буде повторено автоматично.',
  'chat.amrCard.chipOfficial': 'Офіційний хостинг',
  'chat.amrCard.chipNoKey': 'Без API-ключа',
  'chat.amrCard.chipAutoRetry': 'Авто-повтор після входу',
  'chat.amrCard.switchCta': 'Перейти на AMR і повторити',
  'chat.amrError.authMessage': 'Ваш обліковий запис AMR ще не авторизовано. Авторизуйте, і це виконання буде повторено автоматично.',
  'chat.amrError.balanceMessage': 'Баланс AMR вичерпано. Поповніть, щоб продовжити це виконання.',
  'chat.amrError.authorizeCta': 'Авторизувати та повторити',
  'chat.amrError.rechargeCta': 'Поповнити AMR',
  'chat.antigravityError.launchTerminalCta': 'Sign in via terminal',
  'chat.antigravityError.launchSwitchModelCta': 'Switch model in terminal',
  'plugins.actions.copyInstallCommand': 'Скопіювати команду встановлення',
  'plugins.actions.copyPluginId': 'Скопіювати ID плагіна',
  'plugins.actions.copyReadmeBadge': 'Скопіювати бейдж README',
  'plugins.actions.openSourceGithub': 'Відкрити код на GitHub',
  'plugins.actions.openSource': 'Відкрити код',
  'plugins.actions.openHomepage': 'Відкрити домашню сторінку',
  'plugins.actions.openMarketplace': 'Відкрити в маркетплейсі',
  'workingDirPicker.title': "Folder",
  'workingDirPicker.homeTitle': "Choose where this project should live",
  'workingDirPicker.processing': "Processing…",
  'workingDirPicker.select': "Choose working directory",
  'workingDirPicker.clearAria': "Clear working directory",
  'workingDirPicker.replaceFailed': "Could not replace working directory",
  'workingDirPicker.unavailable': "Folder picker is unavailable in this build. Run the desktop app to pick a folder.",
  'workingDirPicker.openUnavailable': "Open this project in the desktop app to show the folder.",
  'workingDirPicker.openFailed': "Could not show this folder",
  'workingDirPicker.showInFileManager': "Show in file manager",
  'workingDirPicker.replace': "Clear and replace directory…",
  'workingDirPicker.recent': "Recent directories",
  'handoff.toTarget': 'Hand off to {target}',
  'handoff.action': 'Hand off',
  'handoff.fallbackTitle': 'No editors found on $PATH - opens in {target}',
  'handoff.chooseTargetAria': 'Choose hand-off target',
  'handoff.notInstalled': 'Not installed',
  'handoff.notDetectedTitle': '{target} - not detected on $PATH',
  'homeHero.promptExamples': "Приклади",
  'homeHero.footer.designSystem': "Стиль",
  'homeHero.footer.autoDesignSystem': "Авто",
  'homeHero.footer.autoDesignSystemSummary': "Автоматично добирає дизайн-систему й візуальний стиль для поточного промпта.",
  'homeHero.footer.ratio': "Співвідношення",
  'homeHero.footer.duration': "Тривалість",
  'homeHero.footer.resolution': "Роздільність",
  'homeHero.footer.speakerNotes': "Notes",
  'homeHero.footer.noSpeakerNotes': "Без нотаток",
  'homeHero.footer.availableCount': "{n} available",
  'homeHero.footer.noMatches': "No matches",
  'homeHero.moreShortcuts': "Більше",
  'common.cancel': 'Скасувати',
  'common.save': 'Зберегти',
  'common.close': 'Закрити',
  'common.delete': 'Видалити',
  'common.rename': 'Перейменувати',
  'common.edit': 'Редагувати',
  'common.preview': 'Переглянути',
  'common.share': 'Поділитися',
  'common.search': 'Пошук',
  'common.searchEllipsis': 'Пошук…',
  'common.loading': 'Завантаження…',
  'common.all': 'Все',
  'common.none': 'Жодного',
  'common.default': 'За замовчуванням',
  'common.installed': 'встановлено',
  'common.notInstalled': 'не встановлено',
  'common.active': 'активно',
  'common.offline': 'вимкнено',
  'common.selected': 'вибрано',
  'common.create': 'Створити',
  'common.openPreview': 'Відкрити попередній перегляд',
  'common.exitFullscreen': 'Вийти з повноекранного режиму',
  'common.fullscreen': 'Повноекранний режим',
  'common.openInNewTab': 'Відкрити в новій вкладці',
  'common.exportPdf': 'Експортувати як PDF',
  'common.exportZip': 'Завантажити як .zip',
  'common.exportHtml': 'Експортувати як HTML автономно',
  'common.exportImage': 'Експортувати як зображення',
  'common.exportImageFailed': 'Не вдалося захопити зображення. Спробуйте ще раз або скористайтеся інструментом знімків екрана браузера.',
  'common.justNow': 'щойно',
  'common.minutesAgo': '{n}хв тому',
  'common.hoursAgo': '{n}г тому',
  'common.daysAgo': '{n}дн тому',
  'common.weeksAgo': '{n}w ago',
  'common.now': 'тепер',
  'common.minutesShort': '{n}хв',
  'common.hoursShort': '{n}г',
  'common.daysShort': '{n}дн',
  'common.untitled': 'Без назви',

  'app.brand': 'Open Design',
  'app.brandPill': 'Попередній перегляд',
  'app.brandSubtitle': 'від Nexu Labs',
  'app.welcomeLoading': 'Завантаження робочого простору…',

  'settings.welcomeKicker': "",
  'settings.welcomeTitle': "Welcome",
  'settings.welcomeSubtitle': "",
  'settings.onboardingCreateTitle': 'Start from a brief',
  'settings.onboardingCreateBody':
    'Describe the site, app, deck, image, or video you want. Open Design will create a project and keep the work editable.',
  'settings.onboardingMemoryTitle': 'Save working context',
  'settings.onboardingMemoryBody':
    'Add preferences, project facts, and recurring rules so future chats pick up the right context.',
  'settings.onboardingSystemsTitle': 'Bring your design system',
  'settings.onboardingSystemsBody':
    'Pick or create a brand system so generated work follows real colors, typography, and product language.',
  'settings.onboardingExecutionTitle': 'Choose how generation runs',
  'settings.onboardingExecutionBody':
    'Official CLI with one-click setup and ready-to-use defaults. Use one key to choose from many models with better pricing.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Офіційно рекомендовано',
  'settings.onboardingAmrCloudBenefitReady': 'Без розгортання',
  'settings.onboardingAmrCloudBenefitModels': 'Підтримує Claude Opus 4.8',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA Harness',
  'settings.onboardingAmrCloudUpcomingLabel': 'Незабаром',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Зображення й відео',
  'settings.onboardingAmrCloudUpcomingSkills': 'Багато Skills',
  'settings.onboardingAmrCloudUpcomingRouting': 'Розумна маршрутизація',
  'settings.onboardingAmrModelSourceLabel': 'AMR CLI',
  'settings.onboardingAmrCloudAuthorizeAction': 'Авторизувати AMR',
  'settings.onboardingAmrCloudAuthorizedAction': 'Авторизовано',
  'settings.onboardingStepConnect': "Connect",
  'settings.onboardingStepDesignSystem': "Design system",
  'settings.onboardingStepProfile': "About you",
  'settings.onboardingConnectTitle': "Choose a runtime",
  'settings.onboardingConnectBody': "",
  'settings.onboardingRecommended': "Recommended",
  'settings.onboardingLocalTitle': "Local coding agent",
  'settings.onboardingLocalBody': "Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.",
  'settings.onboardingLocalAction': "Open CLI settings",
  'settings.onboardingCliScanHint': "This usually takes 5-10 seconds.",
  'settings.onboardingByokTitle': "Bring your own key",
  'settings.onboardingByokBody': "Use your own model provider credentials.",
  'settings.onboardingByokAction': "Open BYOK settings",
  'settings.onboardingDesignTitle': "Design system",
  'settings.onboardingDesignBody': "Generate once, reuse everywhere.",
  'settings.onboardingDesignIntroGenerateTitle': "Generate from existing work",
  'settings.onboardingDesignIntroGenerateBody': "Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.",
  'settings.onboardingDesignIntroReuseTitle': "Reuse in future work",
  'settings.onboardingDesignIntroReuseBody': "Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.",
  'settings.onboardingDesignIntroSkipTitle': "Optional for now",
  'settings.onboardingDesignIntroSkipBody': "Skip this step if you want to start without generating a design system.",
  'settings.onboardingGithubTitle': "Import from GitHub",
  'settings.onboardingGithubBody': "Use a frontend repository.",
  'settings.onboardingUploadTitle': "Upload local files",
  'settings.onboardingUploadBody': "Add project files, screenshots, CSS, docs, or assets.",
  'settings.onboardingPromptTitle': "Generate from prompt",
  'settings.onboardingPromptBody': "Describe the product or brand.",
  'settings.onboardingProfileTitle': "About you",
  'settings.onboardingProfileBody': "Optional details for better defaults.",
  'settings.onboardingRoleLabel': "Your role",
  'settings.onboardingOrgSizeLabel': "Organization size",
  'settings.onboardingUseCaseLabel': "Use case",
  'settings.onboardingSourceLabel': "Where did you hear about us?",
  'settings.onboardingSelectPlaceholder': "Select one",
  'settings.onboardingSelectMultiplePlaceholder': "Select one or more",
  'settings.onboardingOrgSolo': "Solo / personal (1)",
  'settings.onboardingOrgTeam': "Small team (2-10)",
  'settings.onboardingOrgStartup': "Startup / SMB (11-50)",
  'settings.onboardingOrgGrowth': "Growth company (51-200)",
  'settings.onboardingOrgMidMarket': "Mid-market (201-1000)",
  'settings.onboardingOrgEnterprise': "Enterprise (1000+)",
  'settings.onboardingRolePm': "📋 Product manager",
  'settings.onboardingRoleDesigner': "🎨 Designer",
  'settings.onboardingRoleEngineer': "💻 Engineer",
  'settings.onboardingRoleMarketing': "📣 Marketing",
  'settings.onboardingRoleGrowth': "📈 Growth",
  'settings.onboardingRoleOps': "⚙️ Operations",
  'settings.onboardingRoleFounder': "🚀 Founder / executive",
  'settings.onboardingRoleStudent': "🎓 Student / educator",
  'settings.onboardingRoleOther': "✨ Other",
  'settings.onboardingUseProduct': "🎨 Product design",
  'settings.onboardingUseDesignSystem': "🧩 Design system",
  'settings.onboardingUsePrototype': "📱 Prototype / app UI",
  'settings.onboardingUseLanding': "🌐 Landing pages",
  'settings.onboardingUseAds': "📣 Ads / social content",
  'settings.onboardingUseDashboard': "📊 Dashboards / internal tools",
  'settings.onboardingUseDeck': "🖥️ Presentation / deck",
  'settings.onboardingUseMarketing': "📈 Marketing / growth",
  'settings.onboardingUseEngineering': "🤝 Engineering handoff",
  'settings.onboardingUseAgency': "💼 Agency / client work",
  'settings.onboardingSourceGithub': "🐙 GitHub",
  'settings.onboardingSourceFriend': "👥 Friend or coworker",
  'settings.onboardingSourceSocial': "📱 Social media",
  'settings.onboardingSourceProductHunt': "🅿️ Product Hunt",
  'settings.onboardingSourceCommunity': "💬 Design / AI community",
  'settings.onboardingSourceYoutube': "▶️ YouTube",
  'settings.onboardingSourceBlog': "📰 Blog or newsletter",
  'settings.onboardingSourceAiTool': "✨ AI tool recommendation",
  'settings.onboardingSourceSearch': "🔍 Search",
  'settings.onboardingSourceEvent': "🎤 Event or community",
  'settings.onboardingBack': "Back",
  'settings.onboardingContinue': "Continue",
  'settings.onboardingFinish': "Finish setup",
  'settings.onboardingSkip': "Skip for now",
  'settings.kicker': 'Налаштування',
  'settings.title': 'Режим виконання',
  'settings.subtitle': 'Виберіть локальний CLI або BYOK.',
  'settings.modeAria': 'Режим виконання',
  'settings.protocolAria': 'Протокол API',
  'settings.modeDaemon': 'Локальний CLI',
  'settings.modeDaemonHelp': 'Запуск через CLI кодового агента на вашому комп\'ютері',
  'settings.modeDaemonOffline': 'Фоновий процес не запущений',
  'settings.modeDaemonOfflineMeta': 'Фоновий процес офлайн',
  'settings.modeDaemonInstalledMeta': '{count} встановлено',
  'settings.modeApi': 'API-провайдер',
  'settings.modeApiMeta': 'BYOK',
  'settings.codeAgent': 'Кодовий агент',
  'settings.codeAgentHint':
    'Виявляється за допомогою сканування вашого PATH. Виберіть CLI, через який мають проходити генерації.',
  'settings.rescan': '↻ Переканувати',
  'settings.rescanTitle': 'Повторно сканувати PATH',
  'settings.rescanRunning': 'Сканування...',
  'settings.rescanSuccess': 'Сканування завершено. Доступно: {count}.',
  'settings.designSystemRenameFailed': 'Не вдалося перейменувати. Перевірте фоновий процес і спробуйте ще раз.',
  'settings.rescanFailed':
    'Сканування не вдалося. Перевірте фоновий процес і спробуйте ще раз.',
  'settings.test': 'Перевірити',
  'settings.testTitle': 'Надішліть крихітний тестовий запит для перевірки з’єднання',
  'settings.testRunning': 'Перевірка з’єднання…',
  'settings.testCancel': 'Скасувати',
  'settings.testSuccessApi': 'З’єднано. Відповідь за {ms} мс — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} відповів за {ms} мс — \'{sample}\'',
  'settings.testAuthFailed': 'Помилка автентифікації. Перевірте ключ API.',
  'settings.testForbidden': 'Доступ заборонено. Перевірте обліковий запис, регіон або організацію.',
  'settings.testNotFoundModel': 'Модель \'{model}\' не знайдено на цій кінцевій точці.',
  'settings.testInvalidModelId': 'ID моделі \'{model}\' недійсний. Власний ID має починатися з літери або цифри й не містити пробілів.',
  'settings.testInvalidBaseUrl': 'Base URL недійсний або недоступний.',
  'settings.testRateLimited': 'Постачальник обмежив тест. Конфігурація виглядає правильною.',
  'settings.testUpstream': 'Постачальник повернув {status}. Спробуйте ще раз за мить.',
  'settings.testTimeout': 'Тест перервано за тайм-аутом після {ms} мс.',
  'settings.testAgentMissing': '{agentName} не встановлено або не знайдено в PATH.',
  'settings.testAgentSpawn': 'Не вдалося запустити {agentName}: {detail}.',
  'settings.testUnknown': 'Тест не виконано: {detail}',
  'settings.agentInstall.install': 'Встановити',
  'settings.agentInstall.docs': 'Документація',
  'settings.agentInstall.pathHint':
    'Якщо ви встановили CLI через npm або Homebrew, але вона все ще відображається як не встановлена, переконайтеся, що bin-каталог інструмента є у PATH, який успадковує daemon Open Design (у macOS PATH у Terminal і GUI-застосунків може відрізнятися). Див. QUICKSTART.md (розділ "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Відкрийте Встановити або Документація для потрібного агента.',
  'settings.agentInstall.stepAuth':
    'Пройдіть автентифікацію у CLI постачальника (увійдіть або додайте API-облікові дані), потім поверніться до Open Design.',
  'settings.agentInstall.stepRescan': 'Натисніть «Пересканувати» у цьому розділі.',
  'settings.agentInstall.stepSelect': 'Виберіть картку агента, коли він з\'явиться як встановлений.',
  'settings.noAgentsDetected':
    'Агентів ще не виявлено. Встановіть один з: Claude Code, Codex, Devin for Terminal, Gemini CLI, OpenCode, Cursor Agent, Qwen або GitHub Copilot CLI, а потім натисніть Переканувати.',
  'settings.agentInstalledGroup': 'Ваші CLI ({count})',
  'settings.agentInstallGroup': 'Доступні для встановлення ({count})',
  'settings.agentAuthRequired': 'Потрібна автентифікація',
  'settings.agentAuthUnknown': 'Стан автентифікації невідомий',
  'settings.amrLogin': 'Sign in',
  'settings.amrLogout': 'Sign out',
  'settings.amrLoggingIn': 'Signing in…',
  'settings.amrLoggingOut': 'Signing out…',
  'settings.amrLoggedInAs': 'Signed in as {email}',
  'settings.amrLoggedInWithPlan': 'Signed in as {email} · {plan}',
  'settings.amrLoggedInPill': 'Signed in',
  'settings.amrNotLoggedIn': 'Not signed in',
  'settings.amrCloud': 'Open Design AMR',
  'settings.amrAuthorize': 'Authorize',
  'settings.amrBenefitOfficial': 'Officially maintained',
  'settings.amrBenefitLowerPrice': 'Lower price',
  'settings.amrBenefitManyModels': 'Many models',
  'settings.amrPromoBonus': 'Limited bonus: +100%',
  'settings.amrSignInToContinue': 'Sign in to continue',
  'settings.amrSignIn': 'Sign in',
  'settings.amrSignedIn': 'Signed in',
  'settings.amrNotSignedIn': 'Not signed in',
  'settings.amrSigningIn': 'Signing in…',
  'settings.amrCancelSignIn': 'Cancel sign-in',
  'settings.amrAccountStatus': 'AMR account status',
  'settings.amrLoginErrorCompact': 'AMR sign-in failed.',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'Швидко заповнити провайдера',
  'settings.customProvider': 'Власний провайдер',
  'settings.apiKey': 'API-ключ',
  'settings.showKey': 'Показати ключ',
  'settings.hideKey': 'Приховати ключ',
  'settings.show': 'Показати',
  'settings.hide': 'Приховати',
  'settings.model': 'Модель',
  'settings.suggestedModelsHint':
    'Це рекомендовані моделі для цього протоколу. Ваш провайдер може підтримувати інші моделі.',
  'settings.baseUrl': 'Базовий URL',
  'settings.baseUrlInvalid': 'Введіть дійсний публічний URL з http:// або https://. Localhost дозволено; IP приватних мереж блокуються.',
  'settings.baseUrlCustomize': 'Налаштувати',
  'settings.baseUrlDefaultHint': 'Типовий кінцевий пункт. Зазвичай його не потрібно змінювати.',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Find this in Azure portal → your resource → Endpoint.',
  'settings.azureDeploymentModel': 'Назва розгортання',
  'settings.azureDeploymentModelHint':
    'Для Azure OpenAI це поле використовується як назва розгортання в /openai/deployments/<model>. Введіть назву розгортання, створену в Azure.',
  'settings.apiVersion': 'Версія API',
  'settings.byokImageModel': 'Модель генерації зображень',
  'settings.maxTokens': 'Макс. токенів (необов\'язково)',
  'settings.maxTokensHint':
    'Обмеження на довжину відповіді. Кожна модель має налаштовану за замовчуванням (показано в заповнювачі); залиште поле порожнім, щоб використовувати її, або введіть число, щоб переопрацювати.',
  'settings.apiHint': 'Запити надсилаються через локальний проксі daemon до вказаного Base URL. Ключ зберігається лише в цьому браузері й надсилається із запитами до провайдера.',
  'settings.skipForNow': 'Пропустити зараз',
  'settings.getStarted': 'Почати',
  'settings.envConfigure': 'Режим виконання',
  'settings.localCli': 'Локальний CLI',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'агент не вибран',
  'settings.language': 'Мова',
  'settings.languageHint': 'Перемкніть мову інтерфейсу. Зберігається в цьому браузері.',
  'settings.appearance': 'Зовнішній вигляд',
  'settings.appearanceHint': 'Виберіть світлу, темну тему або дотримуйтеся системного параметра.',
  'settings.themeSystem': 'Системна',
  'settings.themeLight': 'Світла',
  'settings.themeDark': 'Темна',
  'settings.agentModelHead': 'Модель для:',
  'settings.modelPicker': 'Модель',
  'settings.modelSourceLive': 'Наживо з CLI',
  'settings.modelSourceFallback': 'Вбудований список',
  'settings.reasoningPicker': 'Інтенсивність міркувань',
  'settings.modelPickerHint':
    'Отримується з CLI, коли він виявляє команду `models`. «За замовчуванням» залишає вибір конфігурації CLI; «Власна…» дозволяє ввести будь-яке ID моделі, яке приймає CLI.',
  'settings.modelPickerLiveHint':
    'Моделі оновлено з установленого CLI. Типовий варіант і далі використовує конфігурацію CLI.',
  'settings.modelPickerFallbackHint':
    'Показано вбудовані типові значення. Натисніть Переканувати, щоб отримати актуальні моделі з CLI.',
  'settings.cliEnvTitle': 'CLI config locations',
  'settings.cliEnvHint':
    'Set non-secret config directories for packaged app runs and agent detection.',
  'settings.cliEnvClaudeConfigDir': 'Claude Code config directory',
  'settings.cliEnvClaudeBaseUrl': 'Claude proxy base URL',
  'settings.cliEnvClaudeApiKey': 'Claude proxy API key',
  'settings.cliEnvCodexHome': 'Codex home',
  'settings.cliEnvCodexBin': 'Codex executable path',
  'settings.cliEnvCodexBaseUrl': 'Codex/OpenAI proxy base URL',
  'settings.cliEnvCodexApiKey': 'Codex/OpenAI proxy API key',
  'settings.modelCustom': 'Власна (введіть нижче)…',
  'settings.modelCustomLabel': 'Власне ID моделі',
  'settings.modelCustomPlaceholder': 'напр. anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Медіа-провайдери',
  'settings.mediaProvidersHint':
    'API-ключі для генерації зображень, відео та аудіо. Зберігаються локально та синхронізуються з локальним фоновим процесом.',
  'settings.mcpServerTitle': 'MCP-сервер',
  'settings.mcpServerHint': 'Відкрийте Open Design як MCP-сервер для вашого кодинг-агента.',
  'settings.externalMcpTitle': 'Зовнішній MCP',
  'settings.externalMcpHint': 'Додайте MCP-інструменти із зовнішніх сервісів (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'API-ключ',
  'settings.mediaProviderBaseUrl': 'Базовий URL',
  'settings.mediaProviderConfigured': 'Налаштовано',
  'settings.mediaProviderUnset': 'Не встановлено',
  'settings.mediaProviderClear': 'Очистити',
  'settings.mediaProviderClearConfirm': 'Видалити збережені налаштування {name}? Вам доведеться ввести їх знову, щоб використовувати {name}.',
  'settings.mediaProviderPlaceholder': 'Вставте API-ключ',
  'settings.mediaProviderBaseUrlPlaceholder': 'Переопрацювати базовий URL за замовчуванням',
  'settings.mediaProviderReload': 'Перезавантажити з локального демона',
  'settings.mediaProviderReloadError': 'Не вдалося повторно завантажити налаштування медіапровайдерів із локального демона.',
  'settings.mediaProviderReloadSuccess': 'Налаштування медіапровайдерів повторно завантажено з локального демона.',
  'settings.mediaProviderLoadError': 'Не вдалося завантажити налаштування медіапровайдерів із локального демона. Наразі використовуються налаштування, збережені в браузері.',
  'settings.mediaProviderComingSoonHint': 'Ми відстежуємо їх у дорожній карті; демон ще не постачає клієнт, тому налаштовувати нічого.',
  'settings.privacy': 'Privacy',
  'settings.privacyHint': 'What data is shared with the Open Design team',
  'settings.privacyConsentKicker': 'Help us improve Open Design',
  'settings.privacyConsentLead': 'Open Design can share usage data with our team to help us improve. This includes:',
  'settings.privacyConsentFooter': 'You can change either of these any time in Settings → Privacy. We never upload the contents of your generated artifact files.',
  'settings.privacyConsentShare': 'Share usage data',
  'settings.privacyConsentDecline': "Don't share",
  'settings.privacyConsentAccept': 'I get it',
  'settings.privacyConsentBannerFooter':
    'Data sharing is on by default. You can turn it off any time in Settings → Privacy. We never upload the contents of your generated artifact files.',
  'settings.privacyConsentPolicyLink': 'Read the privacy policy',
  'settings.privacyMetrics': 'Anonymous metrics',
  'settings.privacyMetricsHint': 'Run counts, token usage, error rate, duration. No prompts, no project data.',
  'settings.privacyContent': 'Conversation content',
  'settings.privacyContentHint': "Your prompts and the assistant's responses (truncated 8 KB / 16 KB). API keys, tokens, JWTs, emails, IPs, and credit-card numbers are stripped automatically before send.",
  'settings.privacyArtifacts': 'Project artifacts manifest',
  'settings.privacyArtifactsHint': 'Filenames, types, sizes of generated files. File contents are never sent.',
  'settings.privacyInstallationId': 'Anonymous ID',
  'settings.privacyOptedOut': 'opted out',
  'settings.privacyDataDeletion': 'Delete my data',
  'settings.privacyDataDeletionHint': 'Rotates your anonymous ID and stops sending. Existing traces age out under our retention policy.',
  'settings.about': 'Про програму',
  'settings.aboutHint': 'Деталі версії та виконання',
  'settings.appVersion': 'Версія',
  'settings.appChannel': 'Канал',
  'settings.appRuntime': 'Середовище виконання',
  'settings.appPlatform': 'Платформа',
  'settings.appArchitecture': 'Архітектура',
  'settings.runtimePackaged': 'Упакований додаток',
  'settings.runtimeDevelopment': 'Розробка',
  'settings.versionUnavailable': 'Деталі версії недоступні, поки фоновий процес перебуває в офлайні.',
  'settings.installLatest': 'Встановити останню версію',
  'settings.alreadyLatest': 'У вас встановлена остання версія',

  'entry.tabDesigns': 'Дизайни',
  'entry.tabTemplates': 'Шаблони',
  'entry.tabDesignSystems': 'Системи дизайну',
  'entry.tabConnectors': 'Конектори',
  'entry.openSettingsTitle': 'Налаштування',
  'entry.openSettingsAria': 'Відкрити налаштування',
  'entry.resizeAria': 'Змінити розмір бічної панелі',
  'entry.loadingWorkspace': 'Завантаження робочого простору…',
  'entry.useEverywhereTitle': 'Використовувати скрізь',
  'entry.useEverywhereAria': 'Відкрити довідник «Використовувати скрізь» (CLI, MCP, HTTP, Skills)',
  'entry.navNewProject': 'Новий проєкт',
  'entry.navHome': 'Головна',
  'entry.navProjects': 'Проєкти',
  'entry.navDesignSystems': 'Дизайн-системи',
  'entry.helpAria': 'Довідка',
  'entry.helpMenuAria': 'Меню довідки',
  'entry.helpGetHelp': 'Отримати допомогу на GitHub',
  'entry.helpSubmitFeature': 'Запропонувати функцію',
  'entry.helpWhatsNew': 'Що нового',
  'entry.helpDownloadDesktop': 'Завантажити настільний застосунок',
  'entry.githubStarLabel': 'Star',
  'entry.githubStarTitle': 'Поставте нам зірку на GitHub',
  'entry.githubStarAria': 'Поставити Open Design зірку на GitHub',
  'entry.tabImageTemplates': 'Шаблони зображень',
  'entry.tabVideoTemplates': 'Шаблони відеороликів',
  'promptTemplates.searchPlaceholder': 'Пошук шаблонів…',
  'promptTemplates.countLabel': '{n} результатів',
  'promptTemplates.allSources': 'Усі джерела',
  'promptTemplates.sourceFilterAria': 'Фільтрувати за джерелом',
  'promptTemplates.emptyImage': 'Шаблонів підказок для зображень ще не встановлено.',
  'promptTemplates.emptyVideo': 'Шаблонів підказок для відео ще не встановлено.',
  'promptTemplates.emptyNoMatch': 'Немає шаблонів, що відповідають вашому пошуку.',
  'promptTemplates.attributionFooter': 'Адаптовано з публічних бібліотек підказок. Кожна картка посилається на автора.',
  'promptTemplates.openPreviewTitle': 'Відкрити підказку та попередній перегляд',
  'promptTemplates.sourcePrefix': 'Джерело:',
  'promptTemplates.fetchError': 'Не вдалося завантажити текст цього шаблону.',
  'promptTemplates.promptLabel': 'Текст підказки',
  'promptTemplates.copyPrompt': 'Копіювати підказку',
  'promptTemplates.copyDone': 'Скопійовано!',
  'promptTemplates.modelHint': 'Рекомендована модель: {model}',
  'promptTemplates.openSource': 'Переглянути оригінал',
  'promptTemplates.openFullscreen': 'Відкрити попередній перегляд у повноекранному режимі',
  'promptTemplates.closeFullscreen': 'Закрити попередній перегляд у повноекранному режимі',
  'promptTemplates.retry': 'Повторити',

  'connectors.title': 'Конектори',
  'connectors.subtitle': 'Локальні та майбутні джерела даних, які можуть живити live-артефакти.',
  'connectors.account': 'Обліковий запис',
  'connectors.noAccount': 'Не підключено',
  'connectors.tools': 'Інструменти',
  'connectors.connect': 'Підключити',
  'connectors.disconnect': 'Відключити',
  'connectors.authorizationPending': 'Очікування авторизації...',
  'connectors.authorizationPendingHint': 'Завершіть авторизацію у відкритому вікні.',
  'connectors.cancelAuthorization': 'Скасувати',
  'connectors.configure': 'Налаштувати',
  'connectors.unavailable': 'Недоступно',
  'connectors.phaseStubTitle': 'API конекторів зʼявляться у фазі 3; це поверхня попереднього перегляду.',
  'connectors.statusAvailable': 'Доступно',
  'connectors.statusConnected': 'Підключено',
  'connectors.statusError': 'Помилка',
  'connectors.statusDisabled': 'Вимкнено',
  'connectors.gateTitle': 'Додайте ключ Composio API, щоб продовжити',
  'connectors.gateBody': 'Вставте ключ вище й натисніть «Зберегти ключ», щоб завантажити доступні інтеграції.',
  'connectors.aboutLabel': 'Про',
  'connectors.detailsLabel': 'Деталі',
  'connectors.statusLabel': 'Статус',
  'connectors.category.aiAgents': 'AI-агенти',
  'connectors.category.aiInfrastructure': 'AI-інфраструктура',
  'connectors.category.accounting': 'Бухгалтерія',
  'connectors.category.admin': 'Адміністрування',
  'connectors.category.advertising': 'Реклама',
  'connectors.category.analytics': 'Аналітика',
  'connectors.category.automation': 'Автоматизація',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Календар',
  'connectors.category.commerce': 'Комерція',
  'connectors.category.communication': 'Комунікації',
  'connectors.category.contacts': 'Контакти',
  'connectors.category.dataPlatform': 'Платформа даних',
  'connectors.category.database': 'База даних',
  'connectors.category.design': 'Дизайн',
  'connectors.category.developer': 'Інструменти розробника',
  'connectors.category.documentation': 'Документація',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Освіта',
  'connectors.category.email': 'Пошта',
  'connectors.category.events': 'Події',
  'connectors.category.fieldService': 'Виїзне обслуговування',
  'connectors.category.finance': 'Фінанси',
  'connectors.category.fitness': 'Фітнес',
  'connectors.category.forms': 'Форми',
  'connectors.category.gaming': 'Ігри',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'Гостинність',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Інтеграція',
  'connectors.category.localization': 'Локалізація',
  'connectors.category.logistics': 'Логістика',
  'connectors.category.maps': 'Карти',
  'connectors.category.marketing': 'Маркетинг',
  'connectors.category.media': 'Медіа',
  'connectors.category.meetings': 'Зустрічі',
  'connectors.category.nonprofit': 'Неприбуткові',
  'connectors.category.observability': 'Спостережуваність',
  'connectors.category.payments': 'Платежі',
  'connectors.category.personal': 'Особисте',
  'connectors.category.presentations': 'Презентації',
  'connectors.category.procurement': 'Закупівлі',
  'connectors.category.product': 'Продукт',
  'connectors.category.productivity': 'Продуктивність',
  'connectors.category.projectManagement': 'Керування проєктами',
  'connectors.category.recruiting': 'Рекрутинг',
  'connectors.category.research': 'Дослідження',
  'connectors.category.salesIntelligence': 'Аналітика продажів',
  'connectors.category.scheduling': 'Планування',
  'connectors.category.search': 'Пошук',
  'connectors.category.security': 'Безпека',
  'connectors.category.signing': 'Підписання',
  'connectors.category.social': 'Соціальні мережі',
  'connectors.category.spreadsheets': 'Таблиці',
  'connectors.category.storage': 'Сховище',
  'connectors.category.support': 'Підтримка',
  'connectors.category.surveys': 'Опитування',
  'connectors.category.tasks': 'Завдання',
  'connectors.category.timeTracking': 'Облік часу',
  'connectors.category.video': 'Відео',
  'connectors.category.whiteboard': 'Дошка',
  'connectors.categoryLabel': 'Категорія',
  'connectors.providerLabel': 'Провайдер',
  'connectors.toolsSection': 'Інструменти',
  'connectors.toolsLoading': 'Завантаження інструментів…',
  'connectors.noToolsAvailable': 'Інструментів ще немає. Підключіться, щоб дізнатися, що надає ця інтеграція.',
  'connectors.toolDetailsUnavailable': 'Tool details are unavailable, but this connector reports {n} tools.',
  'connectors.loadMoreTools': 'Load more tools',
  'connectors.openDetailsAria': 'Відкрити деталі {name}',
  'connectors.toolsBadgeNone': 'Немає інструментів',
  'connectors.toolsBadgeOne': '{n} інструмент',
  'connectors.toolsBadgeMany': '{n} інструментів',
  'connectors.searchPlaceholder': 'Пошук конекторів…',
  'connectors.searchAriaLabel': 'Пошук конекторів за назвою, провайдером або інструментом',
  'connectors.searchClear': 'Очистити пошук',
  'connectors.emptyNoMatchTitle': 'Немає конекторів для “{query}”',
  'connectors.emptyNoMatchBody': 'Спробуйте інше ключове слово або очистіть пошук, щоб переглянути весь каталог.',
  'connectors.emptyNoMatchAction': 'Очистити пошук',

  'newproj.tabPrototype': 'Прототип',
  'newproj.tabLiveArtifact': 'Live-артефакт',
  'newproj.tabDeck': 'Презентація',
  'newproj.tabTemplate': 'З шаблону',
  'newproj.tabMedia': 'Медіа',
  'newproj.tabOther': 'Інше',
  'newproj.titlePrototype': 'Новий прототип',
  'newproj.titleLiveArtifact': 'Новий live-артефакт',
  'newproj.titleDeck': 'Нова презентація',
  'newproj.titleTemplate': 'Почати з шаблону',
  'newproj.titleImage': 'Нове зображення',
  'newproj.titleVideo': 'Новий відеоролик',
  'newproj.titleAudio': 'Новий звуковий файл',
  'newproj.titleMedia': 'Новий медіафайл',
  'newproj.titleOther': 'Новий проект',
  'newproj.namePlaceholder': 'Назва проекту',
  'newproj.fidelityLabel': 'Деталізація',
  'newproj.fidelityWireframe': 'Каркас інтерфейсу',
  'newproj.fidelityHigh': 'Висока деталізація',
  'newproj.toggleSpeakerNotes': 'Використовувати нотатки доповідача',
  'newproj.toggleSpeakerNotesHint': 'Менше тексту на слайдах — основні моменти зберігаються в нотатках.',
  'newproj.toggleAnimations': 'Включити анімації',
  'newproj.toggleAnimationsHint':
    'Додати рух (вхід, наведення, переходи) поверх шаблону.',
  'newproj.surfaceOptionsLabel': 'Companion surfaces',
  'newproj.includeLandingPage': 'Include landing page',
  'newproj.includeLandingPageHint':
    'Add a responsive marketing page for ads, waitlists, launch campaigns, app downloads, or product explanation.',
  'newproj.includeOsWidgets': 'Include OS widgets',
  'newproj.includeOsWidgetsHint':
    'Add platform-native home screen, lock screen, or quick-access widgets for mobile/tablet apps.',
  'newproj.includeOsWidgetsDisabledHint':
    'Available when iOS, Android, or tablet app is selected as a target platform.',
  'newproj.templateLabel': 'Шаблон',
  'newproj.noTemplatesTitle': 'Шаблони ще не створені',
  'newproj.noTemplatesBody':
    'Відкрийте будь-який проект, а потім за допомогою меню Поділитися всередині переглядача файлів перетворіть його на шаблон. Шаблони з\'являтимуться тут.',
  'newproj.savedTemplate': 'Збережений шаблон',
  'newproj.fileSingular': 'файл',
  'newproj.filePlural': 'файли',
  'newproj.create': 'Створити',
  'newproj.createLiveArtifact': 'Створити live-артефакт',
  'newproj.createFromTemplate': 'Створити з шаблону',
  'newproj.createDisabledTitle':
    'Спочатку збережіть проект як шаблон (меню Поділитися всередині будь-якого проекту).',
  'newproj.importClaudeZip': 'Імпортувати Claude Design ZIP',
  'newproj.importClaudeZipTitle': 'Імпортувати експорт Claude Design .zip',
  'newproj.importingClaudeZip': 'Імпортування…',
  'newproj.privacyFooter': 'За замовчуванням лише ви можете переглянути свій проект.',
  'newproj.designSystem': 'Система дизайну',
  'newproj.dsNoneFreeform': 'Без — власний варіант',
  'newproj.dsNoneSubtitleEmpty': 'Без системних токенів, виберіть свою палітру',
  'newproj.dsNoneSubtitleSelected': 'Пропустити системні токени. Агент вибирає свою палітру.',
  'newproj.dsCategoryFallback': 'Система дизайну',
  'newproj.dsSearch': 'Пошук систем дизайну…',
  'newproj.dsModeAria': 'Режим вибору',
  'newproj.dsModeSingle': 'Одна',
  'newproj.dsModeMulti': 'Кілька',
  'newproj.dsNoneTitle': 'Без — власний варіант',
  'newproj.dsNoneSub': 'Пропустити системні токени. Агент вибирає свою палітру.',
  'newproj.dsEmpty': 'Системи дизайну, що відповідають "{query}", не знайдені.',
  'newproj.dsFootSingular': 'є лише натхненням.',
  'newproj.dsFootPlural': 'є лише натхненням.',
  'newproj.dsFootClear': 'Очистити',
  'newproj.dsBadgeDefault': 'ТИПОВА',
  'newproj.dsPrimaryFallback': 'Основна',
  'newproj.surfaceImage': 'Зображення',
  'newproj.surfaceVideo': 'Відеоролик',
  'newproj.surfaceAudio': 'Аудіо',
  'newproj.modelLabel': 'Модель',
  'newproj.modelSearch': 'Пошук моделей…',
  'newproj.modelEmpty': 'Жодних збігів.',
  'newproj.modelRecommended': 'Рекомендовано',
  'newproj.modelMissingTitle': 'Виберіть модель',
  'newproj.modelMissingSub': 'Виберіть модель для цієї поверхні.',
  'newproj.aspectLabel': 'Пропорція',
  'newproj.videoLengthLabel': 'Тривалість',
  'newproj.videoLengthSeconds': '{n}с',
  'newproj.audioKindLabel': 'Тип аудіо',
  'newproj.audioKindMusic': 'Музика',
  'newproj.audioKindSpeech': 'Мовлення / TTS',
  'newproj.audioKindSfx': 'Звукові ефекти',
  'newproj.audioDurationLabel': 'Тривалість',
  'newproj.audioDurationSeconds': '{n}с',
  'newproj.voiceLabel': 'Голос',
  'newproj.voicePlaceholder': 'ID голосу провайдера, необов\'язково',
  'newproj.promptTemplateLabel': 'Шаблон для посилання',
  'newproj.promptTemplateNoneTitle': 'Жоден — напишіть власний',
  'newproj.promptTemplateNoneSub': 'Пропустити галерею, описати власний брифінг',
  'newproj.promptTemplateRefSub': 'Шаблон для посилання',
  'newproj.promptTemplateSearch': 'Пошук шаблонів…',
  'newproj.promptTemplateEmpty': 'Для цієї поверхні ще не встановлено жодних шаблонів.',
  'newproj.promptTemplateBodyLabel': 'Підказка (ви можете налаштувати)',
  'newproj.promptTemplateOptimizeHint':
    'Редагуйте що завгодно — ваші зміни переносяться в брифінг агента.',
  'newproj.promptTemplateBodyEmpty':
    'Порожній текст — агент не отримає посилання на шаблон.',
  'newproj.deleteTemplateTitle': 'Видалити шаблон',
  'newproj.deleteTemplateConfirm': 'Видалити «{name}»? Цю дію не можна скасувати.',
  'newproj.deleteTemplateConfirmCta': 'Видалити шаблон',
  'newproj.deleteTemplateError':
    'Не вдалося видалити цей шаблон. Спробуйте ще раз.',
  'newproj.connectorsLabel': 'Конектори',
  'newproj.connectorsHint': 'Надайте агенту доступ до підключених джерел даних для цього live-артефакту.',
  'newproj.connectorsEmptyTitle': 'Поки що немає підключених конекторів',
  'newproj.connectorsEmptyBody': 'Підключіть джерело даних у вкладці Конектори, а потім поверніться, щоб додати його до цього артефакту.',
  'newproj.connectorsEmptyCta': 'Перейти до Конекторів',
  'newproj.connectorsLoading': 'Завантаження конекторів…',
  'newproj.connectorsCountOne': '{n} конектор',
  'newproj.connectorsCountMany': '{n} конекторів',
  'newproj.connectorsManage': 'Керувати конекторами',

  'designs.subRecent': 'Нещодавні',
  'designs.subYours': 'Ваші дизайни',
  'designs.filterAria': 'Фільтрувати проекти',
  'designs.searchPlaceholder': 'Пошук…',
  'designs.emptyNoProjects': 'Проектів ще немає.',
  'designs.emptyNoMatch': 'Проектів, що відповідають пошуку, не знайдено.',
  'designs.deleteTitle': 'Видалити проект',
  'designs.deleteConfirm': 'Видалити "{name}"?',
  'designs.cardFreeform': 'власний варіант',
  'designs.status.notStarted': 'Не розпочато',
  'designs.status.queued': 'У черзі',
  'designs.status.running': 'Виконується',
  'designs.status.awaitingInput': 'Чекає підтвердження',
  'designs.status.succeeded': 'Завершено',
  'designs.status.published': 'Опубліковано',
  'designs.status.failed': 'Помилка',
  'designs.status.canceled': 'Скасовано',
  'designs.viewToggleAria': 'Режим перегляду',
  'designs.viewGrid': 'Вигляд сітки',
  'designs.viewKanban': 'Вигляд дошки',
  'designs.kanbanEmptyColumn': 'Немає дизайнів',
  'designs.deleteAria': 'Видалити проект {name}',
  'designs.menuMore': 'More actions',
  'designs.menuRename': 'Rename',
  'designs.menuDelete': 'Delete',
  'designs.renamePrompt': 'New name for "{name}"',
  'designs.selectMode': 'Select',
  'designs.cancelSelect': 'Cancel',
  'designs.deleteSelected': 'Delete selected',
  'designs.selectedCount': '{n} selected',
  'designs.deleteSelectedConfirm': 'Delete {n} project(s)?',
  'designs.deleteSelectedSuccess': '{n} project(s) deleted successfully.',
  'designs.deleteSelectedPartial': 'Deleted {deleted} project(s); {failed} failed.',
  'designs.tagPrototype': 'Prototype',
  'designs.tagLiveArtifact': 'Live Artifact',
  'designs.tagSlide': 'Slide',
  'designs.tagMedia': 'Media',
  'designs.renameTitle': 'Rename project',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Cancel',
  'designs.badgeLive': 'Live',
  'designs.liveArtifactBadgesAria': 'Мітки live-артефакту',
  'designs.liveCount': '{n} live-артефактів',
  'designs.statusLive': 'Live',
  'designs.statusArchived': 'Архівовано',
  'designs.statusError': 'Помилка',
  'designs.statusRefreshing': 'Оновлення',
  'designs.statusRefreshFailed': 'Оновлення не вдалося',
  'designs.statusRefreshed': 'Оновлено',

  'examples.typeLabel': 'Тип',
  'examples.surfaceLabel': 'Приклади',
  'examples.surfaceWeb': 'Веб',
  'examples.surfaceImage': 'Зображення',
  'examples.surfaceVideo': 'Відеоролик',
  'examples.surfaceAudio': 'Аудіо',
  'examples.scenarioLabel': 'Кейс використання',
  'examples.modeAll': 'Все',
  'examples.modePrototypeDesktop': 'Прототипи · Комп\'ютер',
  'examples.modePrototypeMobile': 'Прототипи · Мобільний',
  'examples.modeDeck': 'Слайди',
  'examples.modeDocument': 'Документи та шаблони',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Live',
  'examples.scenarioGeneral': 'Загальне',
  'examples.scenarioEngineering': 'Інженерія',
  'examples.scenarioProduct': 'Продукт',
  'examples.scenarioDesign': 'Дизайн',
  'examples.scenarioMarketing': 'Маркетинг',
  'examples.scenarioSales': 'Продажі',
  'examples.scenarioFinance': 'Фінанси',
  'examples.scenarioHr': 'HR',
  'examples.scenarioOperations': 'Операції',
  'examples.scenarioSupport': 'Підтримка',
  'examples.scenarioLegal': 'Юридичні послуги',
  'examples.scenarioEducation': 'Освіта',
  'examples.scenarioPersonal': 'Особисте',
  'examples.searchPlaceholder': 'Пошук прикладів…',
  'examples.searchAria': 'Пошук прикладів за назвою',
  'examples.emptyNoSkills': 'Навички недоступні. Чи запущений фоновий процес?',
  'examples.emptyNoMatch': 'Приклади, що відповідають цим фільтрам, не знайдені.',
  'examples.openPreview': '⤢ Відкрити попередній перегляд',
  'examples.loadingPreview': 'Завантаження попереднього перегляду…',
  'examples.hoverPreview': 'Наведіть мишею для попереднього перегляду',
  'examples.usePrompt': 'Використовувати цю підказку',
  'examples.previewModalTitle': 'Відкрити повний попередній перегляд (модальне вікно)',
  'examples.shareTitle': 'Поділитися цим прикладом',
  'examples.shareLoadFirst': 'Спочатку наведіть мишею, щоб завантажити попередній перегляд',
  'examples.unavailablePlaceholder': 'Немає вбудованого попереднього перегляду {kind} — відкрийте, щоб дізнатися більше',
  'examples.shareUnavailable': 'Немає вбудованого попереднього перегляду {kind} для надсилання',
  'examples.shareMenu': 'Поділитися ▾',
  'examples.exportPdfAllSlides': 'Експортувати як PDF (усі слайди)',
  'examples.exportPptxLocked': 'Експортувати як PPTX… (спочатку відкрийте шаблон)',
  'examples.tagSlideDeck': 'Презентація',
  'examples.tagTemplate': 'Шаблон',
  'examples.tagDesignSystem': 'Система дизайну',
  'examples.tagMobilePrototype': 'Мобільний прототип',
  'examples.tagDesktopPrototype': 'Прототип комп\'ютера',
  'examples.tagImage': 'Зображення',
  'examples.tagVideo': 'Відеоролик',
  'examples.tagAudio': 'Аудіо',
  'examples.previewLabel': 'Попередній перегляд',

  'ds.surfaceLabel': 'Приклади',
  'ds.surfaceWeb': 'Веб',
  'ds.surfaceImage': 'Зображення',
  'ds.surfaceVideo': 'Відеоролик',
  'ds.surfaceAudio': 'Аудіо',
  'ds.searchPlaceholder': 'Пошук систем дизайну…',
  'ds.emptyNoMatch': 'Системи дизайну, що відповідають пошуку, не знайдені.',
  'ds.badgeDefault': 'ТИПОВА',
  'ds.preview': 'Попередній перегляд',
  'ds.previewTitle': 'Попередній перегляд системи дизайну',
  'ds.categoryAll': 'Все',
  'ds.categoryUncategorized': 'Без категорії',
  'ds.showcase': 'Витрина',
  'ds.tokens': 'Токени',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'Завантаження DESIGN.md…',

  'avatar.title': 'Обліковий запис та налаштування',
  'avatar.localCli': 'Локальний CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'Використовувати локальний CLI',
  'avatar.useApi': 'Використовувати API · BYOK',
  'avatar.codeAgent': 'Кодовий агент',
  'avatar.rescan': 'Переканувати PATH',
  'avatar.settings': 'Налаштування',
  'avatar.backToProjects': 'Назад до проектів',
  'avatar.metaActive': 'активно',
  'avatar.metaOffline': 'вимкнено',
  'avatar.metaSelected': 'вибрано',
  'avatar.noAgentSelected': 'агент не вибран',
  'avatar.modelSection': 'Модель',
  'avatar.modelLabel': 'Модель',
  'avatar.reasoningLabel': 'Міркування',
  'avatar.customSuffix': '(власна)',

  'inlineSwitcher.chipTitle': 'Перемкнути CLI / модель',
  'inlineSwitcher.chipCli': 'Локальна CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'за замовчуванням',
  'inlineSwitcher.noAgent': 'агент не вибрано',
  'inlineSwitcher.modeLabel': 'Режим',
  'inlineSwitcher.agentLabel': 'Агент',
  'inlineSwitcher.providerLabel': 'Провайдер',
  'inlineSwitcher.modelLabel': 'Модель',
  'inlineSwitcher.useCli': 'Використовувати локальну CLI',
  'inlineSwitcher.useByok': 'Використовувати власний API-ключ',
  'inlineSwitcher.daemonOffline': 'Демон офлайн — відкрийте налаштування',
  'inlineSwitcher.noAgentsDetected': 'CLI не знайдено в PATH',
  'inlineSwitcher.openSettingsForModel': 'Налаштуйте провайдера в Налаштуваннях',
  'inlineSwitcher.missingApiKey': 'Не задано API-ключ — відкрийте Налаштування.',
  'inlineSwitcher.openFullSettings': 'Відкрити налаштування виконання',
  'inlineSwitcher.customSuffix': '(власна)',

  'project.backToProjects': 'Назад до проектів',
  'project.metaFreeform': 'вільна форма',
  'project.resizeChatPanel': 'Змінити розмір панелі чату',
  'project.instructionsActive': 'Активно — додається до кожного повідомлення',
  'chat.tabChat': 'Чат',
  'chat.tabComments': 'Коментарі',
  'chat.commentsSoon': 'Коментарі — скоро',
  'chat.comments.attached': 'Прикріплено до чату',
  'chat.comments.emptyAttached': 'Коментарів не прикріплено.',
  'chat.comments.saved': 'Збережені коментарі',
  'chat.comments.emptySaved': 'Немає збережених коментарів.',
  'chat.comments.add': 'Додати',
  'chat.comments.addAll': 'Додати все',
  'chat.comments.remove': 'Видалити',
  'chat.comments.placeholder': 'Коментар до цього елемента…',
  'chat.comments.addSend': 'Додати та надіслати',
  'chat.comments.updateSend': 'Оновити та надіслати',
  'chat.comments.removeAttachment': 'Видалити прикріплений коментар',
  'chat.comments.removeAttachmentAria': 'Видалити прикріплений коментар для {name}',
  'chat.comments.comment': 'Comment',
  'chat.comments.sendToChat': 'Send to chat',
  'chat.comments.sending': 'Sending…',
  'chat.comments.edit': 'Edit',
  'chat.comments.select': 'Select',
  'chat.comments.selectAll': 'Вибрати все',
  'chat.comments.deselect': 'Deselect',
  'chat.comments.nSelected': '{n} selected',
  'chat.comments.pin': 'Pin',
  'chat.comments.addNote': 'Add note',
  'chat.comments.savedToast': 'Comment saved',
  'chat.comments.pinSavedToast': 'Pin saved',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} captured items',
  'chat.comments.clear': 'Clear',
  'chat.comments.targetImage': 'Image',
  'chat.comments.targetControl': 'Control',
  'chat.comments.targetLink': 'Link',
  'chat.comments.targetText': 'Text',
  'chat.comments.targetSection': 'Section',
  'chat.comments.targetPage': 'Page',
  'chat.comments.targetArea': 'Area',
  'chat.annotationNotePlaceholder': 'Add a note for this mark',
  'chat.annotationQueue': 'Queue',
  'chat.annotationQueueing': 'Queueing...',
  'chat.annotationSending': 'Sending...',
  'chat.annotationSendDisabledReason': 'A task is currently running',
  'chat.annotationPreviewMissing': 'Could not capture the preview. Please try again.',
  'chat.annotationPreviewMissingInk': 'Could not capture the preview. Try again to avoid sending only ink.',
  'chat.annotationTimeout': 'Annotation send timed out. Please try again.',
  'chat.annotationFailed': 'Annotation send failed. Please try again.',
  'chat.annotationProjectCreateFailed': 'Could not create a project, so the annotation was not sent.',
  'chat.annotationUploadFailed': 'Attachment upload failed. Please try again.',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.conversationsTitle': 'Розмови',
  'chat.conversationsAria': 'Історія розмов',
  'chat.newConversation': 'Нова розмова',
  'chat.newConversationsTitle': 'Нова розмова',
  'chat.conversationsHeading': 'Розмови',
  'chat.new': 'Нова',
  'chat.emptyConversations': 'Розмов ще немає.',
  'chat.deleteConversation': 'Видалити розмову',
  'chat.renameConversationLabel': 'Перейменувати "{title}"',
  'chat.deleteConversationConfirm':
    'Видалити "{title}"? Це видалить усі її повідомлення.',
  'chat.untitledConversation': 'Розмова без назви',
  'chat.startTitle': 'Почніть розмову',
  'chat.startHint': "Опишіть, що хочете згенерувати, або почніть з одного з цих прикладів:",
  'chat.fillInputTitle': 'Натисніть, щоб заповнити введення',
  'chat.jumpToLatest': 'Перейти до останнього',
  'chat.scrollToLatest': 'Прокрутити до останнього',
  'chat.you': 'Ви',
  'chat.openFile': 'Відкрити {name}',
  'chat.copyPrompt': 'Копіювати запит',
  'chat.copyDone': 'Скопійовано!',
  'chat.composerPlaceholder': "Опишіть, що хочете згенерувати…",
  'chat.composerHint': "⌘/Ctrl + Enter, щоб надіслати · вкажіть мету, зміст, стиль і формат",
  'chat.cliSettingsTitle': 'Налаштування CLI та моделі',
  'chat.cliSettingsAria': 'Відкрити налаштування CLI та моделі',
  'chat.attachTitle': 'Прикріпити файли (або вставити / перенести)',
  'chat.attachAria': 'Прикріпити файли',
  'chat.importTitle': 'Імпортувати джерела (скоро)',
  'chat.importLabel': 'Імпортувати',
  'chat.importComingSoon': 'Скоро',
  'chat.importSoon': 'Скоро',
  'chat.importFig': 'Завантажити файл .fig',
  'chat.importGitHub': 'Підключити GitHub',
  'chat.importWeb': 'Захопити веб-елемент',
  'chat.importFolder': 'Пов\'язати папку коду',
  'chat.importSkills': 'Навички та системи дизайну',
  'chat.importProject': 'Посилання на інший проект',
  'chat.linkedFolderRemoveAria': 'Видалити пов\'язану папку {path}',
  'chat.linkedFolderNotFound': 'Папка не існує',
  'chat.linkedFolderAlready': 'Ця папка вже пов\'язана',
  'chat.linkedFolderPickError': 'Не вдалося відкрити вибір папки',
  'chat.queuedHeader': 'Queued',
  'chat.queuedToSend': 'to Send',
  'chat.queuedEditQueuedTaskAria': 'Edit queued task',
  'chat.queuedSave': 'Save',
  'chat.queuedCancel': 'Cancel',
  'chat.queuedEdit': 'Edit',
  'chat.queuedMore': 'more queued',
  'chat.queuedFollowUpFallback': 'Queued follow-up',
  'chat.send': 'Надіслати',
  'chat.stop': 'Зупинити',
  'chat.removeAria': 'Видалити {name}',
  'chat.example1Title': 'Редакційна піч-дека',
  'chat.example1Tag': 'Журнал',
  'chat.example1Prompt':
    ' 10-слайдова редакційна презентація для студії дизайну, що залучає стартовий раунд — макет швейцарської сітки, великі серифні заголовки з сміливими літерницями, моноширокі номери розділів, щедрий негативний простір та повнорозмірні фотослайди, чергуючися з текстозасадженими. Обкладинка, бачення, ринок, продукт, результати, команда, пропозиція, контакти.',
  'chat.example2Title': 'SaaS аналітична панель',
  'chat.example2Tag': 'Дані',
  'chat.example2Prompt':
    'Щільна аналітична панель для SaaS з інструментами розробника — смуга KPI з дельтами від тижня до тижня, два нашаровані графіки (MRR та активні робочі простори), світова теплова карта використання, сітка утримання когорти, лідерборд найпопулярніших клієнтів та стрічка подій реального часу. Темна тема, таблична моноширока цифра, акценти спарклайна.',
  'chat.example3Title': 'Довгий скрол річного звіту',
  'chat.example3Tag': 'Редакційне',
  'chat.example3Prompt':
    'Інтерактивний річний звіт для екологічної організації, що не шукає прибутку — довгий скрол редакційного макета, що змішує великі блоки цитат, візуалізацію даних (накопичені бари, анімовані лічильники, хорографічна карта місць проектів), перерви за фотографіями, стіна донорів та остаточний клич. Сучасний шрифт з засічками, безсерифні ярлики графіків, землиста палітра паперу.',

  'preview.shareMenu': 'Поділитися',
  'preview.exportMenu': 'Export',
  'preview.shareTemplateBadge': 'Template',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Copy template link',
  'preview.copyShareText': 'Copy share text',
  'preview.shareSocialGroup': 'Share to social',
  'preview.shareCopyGroup': 'Copy',
  'preview.shareExportGroup': 'Export files',
  'preview.shareCopied': 'Copied',
  'preview.shareCopyFailed': 'Copy failed',
  'preview.shareTextDefault': 'Open Design template: {title}',
  'preview.openInNewTab': 'Відкрити в новій вкладці',
  'preview.exit': '⤓ Вихід',
  'preview.fullscreen': '⤢ Повноекранний режим',
  'preview.closeTitle': 'Закрити (Esc)',
  'preview.loading': 'Завантаження {label}…',
  'preview.errorTitle': 'Не вдалося завантажити цей приклад.',
  'preview.errorBody': 'Не вдалося отримати HTML прикладу. Переконайтеся, що Open Design запущено, і повторіть спробу.',
  'preview.retry': 'Повторити',
  'preview.unavailableTitle': 'Для {noun} немає вбудованого попереднього перегляду.',
  'preview.unavailableBody': 'Запустіть підказку в чаті, щоб згенерувати {kind}-вивід.',
  'preview.nounSkill': 'цієї навички',
  'preview.nounPlugin': 'цього плагіна',
  'preview.nounTemplate': 'цього шаблону',
  'preview.showSidebar': 'Показати {label}',
  'preview.hideSidebar': 'Приховати {label}',

  'misc.savedTemplate': 'Збережений шаблон',
  'misc.primary': 'Основна',
  'misc.designSystem': 'Система дизайну',

  'workspace.designFiles': 'Файли дизайну',
  'workspace.focusMode': 'Focus workspace',
  'workspace.showChat': 'Show chat',
  'workspace.closeTab': 'Закрити вкладку',
  'workspace.deleteFileConfirm': 'Видалити "{name}" з папки проекту?',
  'workspace.deleteSelectedFilesConfirm': 'Видалити {n} вибраних файлів з папки проекту?',
  'workspace.deleteSelectedFilesPartial': 'Не вдалося видалити {n} файл(ів).',
  'workspace.openFromDesignFiles': 'Відкрити файл з',
  'workspace.designFilesLink': 'Файли дизайну',
  'workspace.loadingSketch': 'Завантаження ескізу…',
  'designFiles.title': 'Файли дизайну',
  'designFiles.upload': 'Завантажити файли',
  'designFiles.pasteText': 'Вставити як текстовий файл',
  'designFiles.newSketch': 'Новий ескіз',
  'designFiles.empty': 'Тут з\'являться ваші роботи',
  'designFiles.refresh': 'Оновити',
  'designFiles.delete': 'Видалити',
  'designFiles.searchPlaceholder': 'Пошук файлів…',
  'designFiles.up': 'Вгору',
  'designFiles.back': 'Назад',
  'designFiles.crumbs': 'проект',
  'designFiles.rowMenu': 'Меню рядка',
  'designFiles.openInTab': 'Відкрити на вкладці',
  'designFiles.download': 'Завантажити',
  'designFiles.downloadSelected': 'Завантажити {n} як ZIP',
  'designFiles.clearSelection': 'Очистити виділення',
  'designFiles.selectPage': 'Вибрати все на сторінці',
  'designFiles.selectAll': 'Вибрати все',
  'designFiles.deleteSelected': 'Видалити {n}',
  'designFiles.dropTitle': '⤓ Перенесіть файли сюди',
  'designFiles.dropDesc':
    'Зображення, документи, посилання або папки — агент використовуватиме їх як контекст.',
  'designFiles.upload.title': 'Завантажити файли',
  'designFiles.paste.title': 'Вставити текст як файл',
  'designFiles.upload.label': 'Завантажити',
  'designFiles.paste.label': 'Вставити',
  'designFiles.previewOpen': 'Відкрити',
  'designFiles.previewClose': 'Закрити попередній перегляд',
  'designFiles.modified': 'Змінено {time} · {size}',
  'designFiles.weeksAgo': '{n}тижнів назад',
  'designFiles.groupBy': 'Групувати за',
  'designFiles.groupByKind': 'Тип',
  'designFiles.groupByModified': 'Змінено',
  'designFiles.expandGroup': 'Розгорнути',
  'designFiles.collapseGroup': 'Згорнути',
  'designFiles.sectionPages': 'Сторінки',
  'designFiles.sectionLiveArtifacts': 'Live-артефакти',
  'designFiles.sectionScripts': 'Скрипти',
  'designFiles.sectionImages': 'Зображення',
  'designFiles.sectionSketches': 'Ескізи',
  'designFiles.sectionOther': 'Інше',
  'designFiles.modifiedToday': 'Сьогодні',
  'designFiles.modifiedYesterday': 'Учора',
  'designFiles.modifiedPrevious7Days': 'Останні 7 днів',
  'designFiles.modifiedPrevious30Days': 'Останні 30 днів',
  'designFiles.modifiedOlder': 'Старіші',
  'designFiles.showMore': 'Показати ще +{n}',
  'designFiles.kindHtml': 'Веб-сторінка',
  'designFiles.kindLiveArtifact': 'Live-артефакт',
  'designFiles.kindImage': 'Зображення',
  'designFiles.kindSketch': 'Ескіз',
  'designFiles.kindText': 'Текст',
  'designFiles.kindCode': 'Скрипт',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Документ',
  'designFiles.kindPresentation': 'Презентація',
  'designFiles.kindSpreadsheet': 'Електронна таблиця',
  'designFiles.kindBinary': 'Двійковий',
  'designFiles.kindFolder': 'Папка',
  'designFiles.folderCount': '{n} файлів',
  'designFiles.colName': 'Назва',
  'designFiles.colKind': 'Тип',
  'designFiles.colModified': 'Змінено',
  'designFiles.perPage': 'Показати',
  'designFiles.all': 'Усі',
  'designFiles.prev': 'Назад',
  'designFiles.next': 'Далі',
  'designFiles.jumpToPage': 'Перейти на сторінку',
  'designFiles.pageInfo': '{start}–{end} із {total}',
  'liveArtifact.refresh.button': 'Оновити',
  'liveArtifact.refresh.buttonTitle': 'Оновити live-артефакт',
  'liveArtifact.refresh.loadingTitle': 'Оновлення live-артефакту…',
  'liveArtifact.refresh.noSourceTitle': 'Джерело оновлення недоступне',
  'liveArtifact.refresh.running': 'Оновлення…',
  'liveArtifact.refresh.runningMessage': 'Агент оновлює цей live-артефакт.',
  'liveArtifact.refresh.runningAction': 'Переглянути виконання',
  'liveArtifact.refresh.successOne': 'Оновлення завершено. Дані оновлено.',
  'liveArtifact.refresh.successMany': 'Оновлення завершено. Дані оновлено.',
  'liveArtifact.refresh.successAction': 'Переглянути зміни',
  'liveArtifact.refresh.previousFailure': 'Попереднє оновлення не вдалося: {message}',
  'liveArtifact.refresh.failureAction': 'Переглянути деталі',
  'liveArtifact.refresh.networkFailure': 'Не вдалося звʼязатися з локальним фоновим процесом.',
  'liveArtifact.refresh.genericFailure': 'Не вдалося оновити live-артефакт.',
  'liveArtifact.refresh.statusNever': 'Ще не оновлювався',
  'liveArtifact.refresh.statusReady': 'Готовий до оновлення',
  'liveArtifact.refresh.statusSucceeded': 'Оновлено',
  'liveArtifact.refresh.statusFailed': 'Оновлення не вдалося',
  'quickSwitcher.placeholder': 'Відкрити файл…',
  'quickSwitcher.empty': 'У цьому проєкті немає файлів',
  'quickSwitcher.noMatches': 'Немає збігів',
  'quickSwitcher.navigate': 'навігація',
  'quickSwitcher.open': 'відкрити',
  'quickSwitcher.close': 'закрити',
  'pasteDialog.title': 'Вставити текст',
  'pasteDialog.hint': 'Збережено в папці проекту. Виберіть будь-яку назву.',
  'pasteDialog.fileNameLabel': 'Назва файлу',
  'pasteDialog.namePlaceholder': 'notes.txt',
  'pasteDialog.contentLabel': 'Вміст',
  'pasteDialog.contentPlaceholder': 'Вставте що завгодно…',
  'pasteDialog.save': 'Зберегти',
  'pasteDialog.cancel': 'Скасувати',
  'sketch.save': 'Зберегти ескіз',
  'sketch.cancel': 'Скасувати',
  'sketch.saving': 'Збереження…',
  'sketch.saved': 'Збережено',
  'sketch.tooltipDirty': 'Незбережені зміни',
  'sketch.tooltipClean': 'Збережено',
  'fileViewer.empty': 'Виберіть файл для перегляду.',
  'fileViewer.loading': 'Завантаження…',
  'fileViewer.exportPptx': 'Експортувати як PPTX',
  'fileViewer.openInNewTab': 'Відкрити в новій вкладці',
  'fileViewer.copyPath': 'Копіювати шлях',
  'fileViewer.copied': 'Скопійовано!',
  'fileViewer.share': 'Поділитися',
  'fileViewer.binaryMeta': 'Двійковий · {size}',
  'fileViewer.binaryNote':
    'Двійковий файл ({size} байтів). Завантажте або відкрийте з диска для інспекції.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Документ',
  'fileViewer.presentationMeta': 'Презентація',
  'fileViewer.spreadsheetMeta': 'Електронна таблиця',
  'fileViewer.previewUnavailable': 'Попередній перегляд недоступний. Завантажте або відкрийте файл для інспекції.',
  'fileViewer.download': 'Завантажити',
  'fileViewer.open': 'Відкрити',
  'fileViewer.imageMeta': 'Зображення · {size}',
  'fileViewer.reactMeta': 'React компонент · {size}',
  'fileViewer.sketchMeta': 'Ескіз · {size}',
  'fileViewer.markdownStreamingMeta': 'Попередній перегляд потоку…',
  'fileViewer.markdownErrorMeta': 'Попередній перегляд може бути неповним (помилка генерації).',
  'fileViewer.markdownStreamingStatus': 'Потоком… показано часткове повідомлення.',
  'fileViewer.markdownErrorStatus': 'Помилка генерації. Показано останній доступний вміст.',
  'fileViewer.videoMeta': 'Відеоролик · {size}',
  'fileViewer.audioMeta': 'Аудіо · {size}',
  'fileViewer.reload': 'Перезавантажити',
  'fileViewer.reloadDisk': 'Перезавантажити з диска',
  'fileViewer.copy': 'Копіювати',
  'fileViewer.copyTitle': 'Копіювати вміст файлу',
  'fileViewer.saveDisabled': 'Зберегти (переглядач лише для читання)',
  'fileViewer.save': 'Зберегти',
  'fileViewer.preview': 'Попередній перегляд',
  'fileViewer.source': 'Джерело',
  'fileViewer.tweaks': 'Настройки',
  'fileViewer.tweaksUnavailable': 'Немає панелі налаштувань у цьому артефакті',
  'fileViewer.jsxModuleTitle': 'Немає окремого попереднього перегляду',
  'fileViewer.jsxModuleBody': 'Цей файл є модулем компонента, який завантажує інша сторінка.',
  'fileViewer.jsxModuleCta': 'Відкрийте сторінку, що його відображає:',
  'fileViewer.comment': 'Коментар',
  'fileViewer.edit': 'Редагувати',
  'fileViewer.draw': 'Малювати',
  'fileViewer.mark': 'Mark',
  'fileViewer.markTool': 'Mark tool',
  'fileViewer.boxSelect': 'Box select',
  'fileViewer.screenshot': 'Screenshot',
  'manualEdit.layers': "Layers",
  'manualEdit.editableCount': "{count} editable",
  'manualEdit.hiddenBadge': "Hidden",
  'manualEdit.title': "Manual editor",
  'manualEdit.fallbackTitle': 'Edit',
  'manualEdit.movePanel': 'Move edit panel',
  'manualEdit.closePanel': 'Close edit panel',
  'manualEdit.selectLayer': "Select a layer",
  'manualEdit.empty': "Click an element in the preview or choose a layer.",
  'manualEdit.noEditableLayers': "No editable layers found.",
  'manualEdit.noClass': "no class",
  'manualEdit.tabsAria': "Manual edit tabs",
  'manualEdit.tabContent': "Content",
  'manualEdit.tabStyle': "Style",
  'manualEdit.tabAttributes': "Attributes",
  'manualEdit.tabHtml': "Html",
  'manualEdit.tabSource': "Source",
  'manualEdit.attributesJson': "Attributes JSON",
  'manualEdit.selectedHtml': "Selected element HTML",
  'manualEdit.fullSource': "Full artifact source",
  'manualEdit.applyContent': "Apply Content",
  'manualEdit.applyStyle': "Apply Style",
  'manualEdit.applyAttributes': "Apply Attributes",
  'manualEdit.applyHtml': "Apply HTML",
  'manualEdit.applySource': "Apply Source",
  'manualEdit.invalidAttributes': "Invalid attributes JSON.",
  'manualEdit.changes': "Changes",
  'manualEdit.undo': "Undo",
  'manualEdit.redo': "Redo",
  'manualEdit.noChanges': "No manual edits yet.",
  'manualEdit.imageUrl': "Image URL",
  'manualEdit.altText': "Alt text",
  'manualEdit.label': "Label",
  'manualEdit.text': "Text",
  'manualEdit.href': "Href",
  'manualEdit.textColor': "Text color",
  'manualEdit.background': "Background",
  'manualEdit.fontSize': "Font size",
  'manualEdit.weight': "Weight",
  'manualEdit.align': "Align",
  'manualEdit.padding': "Padding",
  'manualEdit.margin': "Margin",
  'manualEdit.radius': "Radius",
  'manualEdit.border': "Border",
  'manualEdit.width': "Width",
  'manualEdit.minHeight': "Min height",
  'fileViewer.zoomOut': 'Зменшити',
  'fileViewer.zoomIn': 'Збільшити',
  'fileViewer.resetZoom': 'Скинути масштаб',
  'fileViewer.viewportAria': 'Preview viewport',
  'fileViewer.viewportDesktop': 'Desktop',
  'fileViewer.viewportDesktopTitle': 'Full-width desktop preview',
  'fileViewer.viewportTablet': 'Tablet',
  'fileViewer.viewportTabletTitle': 'Tablet preview at 820 × 1180 (modern portrait baseline)',
  'fileViewer.viewportMobile': 'Mobile',
  'fileViewer.viewportMobileTitle': 'Mobile preview at 390 × 844',
  'fileViewer.reloadAria': 'Перезавантажити',
  'fileViewer.previousSlide': 'Попередній слайд',
  'fileViewer.nextSlide': 'Наступний слайд',
  'fileViewer.slideNavAria': 'Навігація по слайдах',
  'fileViewer.present': 'Презентувати',
  'fileViewer.presentInTab': 'На цій вкладці',
  'fileViewer.presentFullscreen': 'Повноекранний режим',
  'fileViewer.presentNewTab': 'Нова вкладка',
  'fileViewer.exitPresentation': 'Вийти з режиму презентації',
  'fileViewer.shareLabel': "Поділитися",
  'fileViewer.shareMenuShareLink': 'SHARE LINK',
  'fileViewer.shareMenuPublishOnline': 'PUBLISH ONLINE',
  'fileViewer.shareMenuDownload': 'DOWNLOAD',
  'fileViewer.shareMenuPresentation': 'Presentation',
  'fileViewer.shareMenuSourceFiles': 'Source files',
  'fileViewer.shareMenuSave': 'SAVE',
  'fileViewer.copyProviderLink': 'Copy {provider} link',
  'fileViewer.copyCloudflareLink': 'Copy Cloudflare link',
  'fileViewer.screenshotCopying': 'Copying screenshot...',
  'fileViewer.screenshotCopied': 'Screenshot copied to clipboard',
  'fileViewer.screenshotClipboardDenied': 'Browser blocked clipboard access',
  'fileViewer.screenshotPreviewLoading': 'Preview is still loading. Try again in a moment.',
  'fileViewer.screenshotCaptureFailed': 'Could not capture the preview. Please try again.',
  'fileViewer.exportPdf': 'Експортувати як PDF',
  'fileViewer.exportPdfAllSlides': 'Експортувати як PDF (усі слайди)',
  'fileViewer.exportPptxBusy': 'Чекайте, поки поточна черга завершиться.',
  'fileViewer.exportPptxHint':
    'Надішліть запит агентові для перетворення цього дизайну на PPTX.',
  'fileViewer.exportPptxNa': 'Експорт PPTX недоступний тут.',
  'fileViewer.exportZip': 'Завантажити як .zip',
  'fileViewer.exportHtml': 'Експортувати як самостійний HTML',
  'fileViewer.exportMd': 'Експортувати як Markdown',
  'fileViewer.exportImage': 'Експортувати як зображення',
  'fileViewer.exportImageFailed': 'Не вдалося захопити зображення. Спробуйте ще раз або скористайтеся інструментом знімків екрана вашого браузера.',
  'fileViewer.exportImageModalSubtitle': 'Виберіть формат, а потім завантажте поточний попередній перегляд як зображення.',
  'fileViewer.exportImageFormatLabel': 'Формат',
  'fileViewer.exportImageSaving': 'Збереження зображення…',
  'fileViewer.exportImageSaved': 'Зображення збережено',
  'fileViewer.exportImageDownloadStarted': 'Завантаження розпочато',
  'fileViewer.exportImageDownloadDetails': '{filename} знаходиться у завантаженнях браузера, якщо вікно «Зберегти як» не з’явилося.',
  'fileViewer.exportJsx': 'Експортувати як JSX',
  'fileViewer.exportReactHtml': 'Експортувати попередній перегляд як HTML',
  'fileViewer.exportStarted': 'Export started',
  'fileViewer.saveAsTemplate': 'Зберегти як шаблон…',
  'fileViewer.savingTemplate': 'Збереження шаблону…',
  'fileViewer.savedTemplate': 'Збережено як "{name}"',
  'fileViewer.savedTemplateFail': 'Не вдалося зберегти шаблон — спробуйте ще раз.',
  'fileViewer.templateNamePrompt': 'Назва шаблону',
  'fileViewer.templateNameDefault': 'Шаблон без назви',
  'fileViewer.templateDescPrompt':
    'Короткий опис (необов\'язково — що робить цей шаблон корисним?)',
  'fileViewer.deployToVercel': 'Розгорнути на Vercel',
  'fileViewer.redeployToVercel': 'Розгорнути повторно',
  'fileViewer.deployingToVercel': 'Розгортання на Vercel…',
  'fileViewer.deployProviderLabel': 'Провайдер',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': 'Розгорнути на {provider}',
  'fileViewer.redeployToProvider': 'Розгорнути повторно на {provider}',
  'fileViewer.deployingToProvider': 'Розгортання на {provider}…',
  'fileViewer.preparingPublicLink': 'Підготовка публічного посилання…',
  'fileViewer.copyDeployLink': 'Копіювати посилання',
    'fileViewer.deployModalTitle': 'Розгорнути',
  'fileViewer.deployModalSubtitle': 'Використайте акаунт вибраного провайдера, щоб розгорнути цей HTML-перегляд.',
  'fileViewer.vercelToken': 'Токен Vercel',
  'fileViewer.vercelTokenGetLink': 'Отримати токен Vercel',
  'fileViewer.vercelTokenPlaceholder': 'Вставте свій токен Vercel',
  'fileViewer.vercelTokenReuseHint': 'Збережений токен буде використаний. Введіть новий токен, щоб замінити його.',
  'fileViewer.vercelTokenRequired': 'Спочатку введіть та збережіть токен Vercel.',
  'fileViewer.cloudflareApiToken': 'Токен API Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'Отримати токен API Cloudflare',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Вставте токен API Cloudflare',
  'fileViewer.cloudflareApiTokenReuseHint': 'Збережений токен API Cloudflare буде використаний. Введіть новий токен, щоб замінити його.',
  'fileViewer.cloudflareApiTokenRequired': 'Спочатку введіть та збережіть токен API Cloudflare.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Pages Edit is required for deploys. Zone Read is required to list domains. DNS Edit is only needed when binding a custom domain.',
  'fileViewer.vercelTeamId': 'ID команди',
  'fileViewer.vercelTeamSlug': 'Слаг команди',
  'fileViewer.cloudflareAccountId': 'ID акаунта',
  'fileViewer.cloudflareAccountIdHint': 'Обов’язково. ID акаунта можна знайти в панелі Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'Спочатку введіть і збережіть Cloudflare Account ID.',
  'fileViewer.cloudflareZoneLabel': 'Domain',
  'fileViewer.cloudflareZonePlaceholder': 'Save Cloudflare settings to load domains',
  'fileViewer.cloudflareZoneRequired': 'Select a Cloudflare domain first.',
  'fileViewer.cloudflareZonesLoading': 'Loading Cloudflare domains…',
  'fileViewer.cloudflareZonesRefresh': 'Refresh domains',
  'fileViewer.cloudflareZonesLoadFailed': 'Could not load Cloudflare domains.',
  'fileViewer.cloudflareZonesEmpty': 'No active full Cloudflare domains were found for this account.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Subdomain prefix',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Use one DNS label only: lowercase letters, numbers, and hyphens.',
  'fileViewer.cloudflareHostnamePreview': 'Custom domain preview: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Optional: choose a Cloudflare domain and prefix to bind a custom subdomain. pages.dev will still be available.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Custom domain',
  'fileViewer.optional': 'Необов’язково',
  'fileViewer.vercelPreviewOnly': 'Розгортання наразі лише для попереднього перегляду.',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages використовує Direct Upload.',
  'fileViewer.savingConfig': 'Збереження…',
  'fileViewer.deployConfigSaveFailed': 'Не вдалося зберегти налаштування Vercel.',
  'fileViewer.deployFailed': 'Розгортання не вдалося. Перевірте налаштування Vercel та спробуйте ще раз.',
  'fileViewer.deployProviderConfigSaveFailed': 'Не вдалося зберегти налаштування {provider}.',
  'fileViewer.deployProviderFailed': 'Розгортання на {provider} не вдалося. Перевірте налаштування й спробуйте ще раз.',
  'fileViewer.deployResultLabel': 'URL розгортання',
  'fileViewer.deployLinkReady': 'Готово',
  'fileViewer.deploySuccessToast': 'Розгортання успішно завантажено',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Публічне посилання очікує',
  'fileViewer.deployLinkDelayed': 'Сайт розгорнуто. Провайдер ще готує публічне посилання.',
  'fileViewer.deployLinkFailed': 'Не вдалося налаштувати власний домен',
  'fileViewer.deployLinkProtectedLabel': 'Захист розгортання ввімкнено',
  'fileViewer.deployLinkProtected': 'Сайт розгорнуто, але це посилання попереднього перегляду вимагає автентифікації. Вимкніть Deployment Protection або використайте власний домен.',
  'fileViewer.retryLink': 'Повторити зараз',

  'questionForm.submit': 'Надіслати',
  'questionForm.skip': 'Пропустити',
  'questionForm.locked': 'Відповідь дано',

  'conv.switch': 'Перемкнути розмову',
  'conv.label': 'Розмова',
  'conv.heading': 'Розмови',
  'conv.new': '+ Нова',
  'conv.empty': 'Розмов ще немає.',
  'conv.untitled': 'Розмова без назви',
  'conv.renameTooltip': 'Двічі натисніть, щоб перейменувати',
  'conv.delete': 'Видалити розмову',
  'conv.deleteConfirm': 'Видалити "{title}"? Це видалить усі її повідомлення.',

  'agentPicker.label': 'Агент',
  'agentPicker.modeChoose': 'Виберіть режим виконання',
  'agentPicker.localCli': 'Локальний CLI',
  'agentPicker.daemonOff': 'фоновий процес вимкнений',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Виберіть виявлений CLI кодового агента',
  'agentPicker.noAgents': 'немає агентів на PATH',
  'agentPicker.notInstalled': 'не встановлено',
  'agentPicker.rescan': 'Повторно сканувати локальний PATH для агентів',

  'tool.openInTab': 'Відкрити {name} на вкладці',
  'tool.open': 'відкрити',
  'tool.todos': 'Завдання',
  'tool.askQuestion': 'Питання',
  'tool.askQuestionSubmit': 'Надіслати',
  'tool.askQuestionPending': 'Очікую вашої відповіді',
  'tool.askQuestionAnswered': 'Відповідь надано',
  'tool.todosExpand': 'Показати завдання',
  'tool.todosCollapse': 'Сховати завдання',
  'tool.todosDone': 'Готово',
  'tool.todosDismiss': 'Закрити список завдань',
  'tool.write': 'Написати',
  'tool.edit': 'Редагувати',
  'tool.read': 'Читати',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Отримати',
  'tool.search': 'Пошук',
  'tool.lines': '{n} рядків',
  'tool.changeSingular': 'змінення',
  'tool.changePlural': 'змінення',
  'tool.in': 'в {path}',
  'tool.hide': 'приховати',
  'tool.output': 'вихід',
  'tool.running': 'виконується…',
  'tool.error': 'помилка',
  'tool.done': 'готово',

  'assistant.role': 'Асистент',
  'assistant.workingLabel': 'Роботи',
  'assistant.doneLabel': 'Готово',
  'assistant.feedbackPrompt': 'Відгук',
  'assistant.feedbackPositive': 'Корисно',
  'assistant.feedbackNegative': 'Не корисно',
  'assistant.feedbackReasonTitle': 'Tell us why',
  'assistant.feedbackReasonPositiveMatched': 'Understood my request',
  'assistant.feedbackReasonPositiveVisual': 'Looks good',
  'assistant.feedbackReasonPositiveUseful': 'Useful structure',
  'assistant.feedbackReasonPositiveEasy': 'Easy to keep editing',
  'assistant.feedbackReasonPositiveDesignSystem': 'Followed the design system',
  'assistant.feedbackReasonNegativeMissed': 'Missed my request',
  'assistant.feedbackReasonNegativeVisual': 'Visual quality needs work',
  'assistant.feedbackReasonNegativeIncomplete': 'Incomplete output',
  'assistant.feedbackReasonNegativeHard': 'Hard to use',
  'assistant.feedbackReasonNegativeDesignSystem': 'Did not follow the design system',
  'assistant.feedbackReasonOther': 'Other',
  'assistant.feedbackReasonPlaceholder': 'Add a short note...',
  'assistant.feedbackReasonSubmit': 'Submit',
  'assistant.emptyResponseLabel': 'No output',
  'assistant.emptyResponseMessage': 'The provider ended the request without returning text or an artifact. Try another model or provider, check quota, or retry.',
  'assistant.unfinishedLabel': 'Зупинено з незавершеною роботою',
  'assistant.unfinishedSummary': 'залишилось {n} завдання(нь)',
  'assistant.unfinishedMore': '+ще {n}',
  'assistant.continueRemaining': 'Продовжити залишкові завдання',
  'assistant.outTokens': '{n} вихід',
  'assistant.producedFiles': 'Файли з цієї черги',
  'assistant.openFile': 'Відкрити',
  'assistant.downloadFile': 'Завантажити',
  'assistant.thinking': 'Мислення',
  'assistant.systemReminder': 'Системне нагадування',
  'assistant.waitingFirstOutput': 'Очікування першого виходу',
  'assistant.statusBootingAgent': 'Завантаження агента',
  'assistant.statusStarting': 'Запуск',
  'assistant.statusRequesting': 'Надсилання запиту',
  'assistant.statusThinking': 'Мислення',
  'assistant.statusStreaming': 'Потоком',
  'assistant.slowHint':
    'Займає більше часу, ніж зазвичай. Форма зазвичай з\'являється за 5–10 с — ви можете зупинити та переформулювати.',
  'assistant.verbEditing': 'Редагування',
  'assistant.verbWriting': 'Написання',
  'assistant.verbReading': 'Читання',
  'assistant.verbSearching': 'Пошук',
  'assistant.verbRunning': 'Виконання',
  'assistant.verbTodos': 'Завдання',
  'assistant.verbFetching': 'Отримання',
  'assistant.verbCalling': 'Виклик',

  'qf.answered': 'відповідь дано',
  'qf.choose': 'Виберіть…',
  'qf.required': 'обов\'язково',
  'qf.lockedSubmitted':
    'Відповіді надіслано — агент використовуватиме їх для решти сеансу.',
  'qf.lockedPrev': 'Ця форма з попередньої черги.',
  'qf.hint':
    'Виберіть те, що підходить. Пропустіть необов\'язкові поля, які вас не цікавлять — агент використовуватиме розумні значення за замовчуванням.',
  'qf.submitDefault': 'Надіслати відповіді',
  'qf.submitDisabledTitle': 'Спочатку заповніть обов\'язкові поля',
  'qf.submitTitle': 'Надіслати відповіді',
  'qf.cardSelected': 'вибрано',
  'qf.cardRefs': 'Посилання:',
  'qf.cardSampleText': 'Швидка коричнева лисиця · 0123',

  'sketch.toolSelect': 'Виділення (без ефекту)',
  'sketch.toolPen': 'Ручка',
  'sketch.toolText': 'Текст',
  'sketch.toolRect': 'Прямокутник',
  'sketch.toolArrow': 'Стрілка',
  'sketch.toolEraser': 'Ластик',
  'sketch.color': 'Колір',
  'sketch.strokeSize': 'Товщина лінії',
  'sketch.undo': 'Скасувати',
  'sketch.clear': 'Очистити',
  'sketch.close': 'Закрити',
  'sketch.closeConfirm': 'Закрити ескіз і скасувати незбережені зміни?',
  'sketch.textPrompt': 'Текст:',
  'sketch.textModalTitle': 'Додати текст',

  'pet.title': 'Маскоти',
  'pet.subtitle': 'Встановити крихітного супутника, який пливе над вашим робочим простором.',
  'pet.navTitle': 'Маскоти',
  'pet.navHint': 'Встановити або налаштувати',
  'pet.tabBuiltIn': 'Вбудовані',
  'pet.tabBuiltInHint': 'Кураторські супутники в комплекті з Open Design — виберіть один та встановіть.',
  'pet.builtInEmpty': 'Вбудовані маскоти наразі недоступні. Спробуйте оновити вкладку Спільнота, коли фоновий процес перейде в мережу.',
  'pet.tabCustom': 'Власна',
  'pet.tabCustomHint': 'Створіть свою власну назвою, гліфом, кольором або спрайтом.',
  'pet.tabCommunity': 'Спільнота',
  'pet.tabCommunityHint': 'Маскоти, створені Codex — встановіть одну або створіть нову.',
  'pet.tabsAria': 'Джерело маскота',
  'pet.adopt': 'Встановити',
  'pet.adoptedBadge': 'Додано',
  'pet.adoptCallout': 'Додати помічника',
  'pet.changePet': 'Змінити маскота',
  'pet.wake': 'Розбудити',
  'pet.tuck': 'Сховати',
  'pet.wakeTitle': 'Розбудити помічника — показати плаваючу накладку.',
  'pet.tuckTitle': 'Сховати помічника — приховати плаваючу накладку.',
  'pet.settingsTitle': 'Відкрити налаштування маскота',
  'pet.useCustom': 'Використовувати мого маскота',
  'pet.customTitle': 'Створіть свою власну',
  'pet.customHint': 'Виберіть назву, гліф та акцент — накладка оновлюється в режимі реального часу.',
  'pet.customGreetingPlaceholder': 'Привіт від вашої домашної тварини…',
  'pet.fieldName': 'Назва',
  'pet.fieldGlyph': 'Гліф',
  'pet.fieldGlyphHint': 'Один емодзі працює найкраще (напр. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Привіт',
  'pet.fieldAccent': 'Колір акценту',
  'pet.fieldAccentCustom': 'Власний колір',
  'pet.fieldAccentDefault': 'Колір акценту за замовчуванням',
  'pet.overlayAria': 'Супутник домашної тварини',
  'pet.spriteAria': '{name} — перетягніть для переміщення, натисніть для чату',
  'pet.spriteTitle': 'Привіт від {name}! Натисніть для чату.',
  'pet.composerTitle': 'Маскоти — розбудити, Сховати або виберіть одну',
  'pet.composerMenuTitle': 'Маскоти',
  'pet.composerMenuHint': 'підказка: введіть /pet для перемикання',
  'pet.composerOpenSettings': 'Керувати вихованцями',
  'pet.welcomeTeaserTitle': 'Встановити маскота',
  'pet.welcomeTeaserBody': 'Крихітний плаваючий супутник, який зависає з вами.',
  'pet.welcomeTeaserCta': 'Виберіть один',
  'pet.imageUpload': 'Завантажити спрайт',
  'pet.imageReplace': 'Замінити спрайт',
  'pet.imageRemove': 'Використовувати емодзі',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF або SVG. Завантаження аркушу? Перенесіть горизонтальну смугу та встановіть кількість кадрів.',
  'pet.imageHintActive': 'Показувати ваш спрайт. Встановіть frames > 1, щоб прогулятися по горизонтальному аркушу спрайтів.',
  'pet.fieldFrames': 'Кадри',
  'pet.fieldFramesHint': '1 = статичне. > 1 = горизонтальний аркуш спрайтів.',
  'pet.fieldFps': 'Швидкість (fps)',
  'pet.fieldFpsHint': 'Наскільки швидко циклюються кадри.',
  'pet.atlasImport': 'Імпортувати спрайт Codex',
  'pet.atlasImportTitle': 'Імпортувати атлас hatch-pet 8x9 / 192x208 (PNG або WebP).',
  'pet.atlasPickerTitle': 'Виберіть рядок анімації',
  'pet.atlasPickerHint': 'Codex маскоти мають 9 рядків анімації. За замовчуванням ми зберігаємо повний атлас, щоб домашна тварина міняла рядки при наведенні, перетягуванні та простої. Ви також можете заморозити його на одному циклі.',
  'pet.atlasCancel': 'Відхилити атлас',
  'pet.atlasAdopt': 'Заморозити цей рядок',
  'pet.atlasAdoptFull': 'Використовувати повний атлас (анімований)',
  'pet.atlasAdoptFullTitle': 'Зберігайте кожен рядок, щоб домашна тварина реагувала на наведення, напрям перетягування та довгі простої.',
  'pet.atlasAdoptRowTitle': 'Розташуйте тільки виділений рядок у єдину циклічну смугу.',
  'pet.atlasActiveHint': 'Активний анімований атлас — домашна тварина вибирає рядок з вашої взаємодії (наведення, перетягування, простій).',
  'pet.atlasRow.idle': 'Простій',
  'pet.atlasRow.running-right': 'Біг вправо',
  'pet.atlasRow.running-left': 'Біг вліво',
  'pet.atlasRow.waving': 'Махання',
  'pet.atlasRow.jumping': 'Стрибання',
  'pet.atlasRow.failed': 'Невдача',
  'pet.atlasRow.waiting': 'Очікування',
  'pet.atlasRow.running': 'Біг',
  'pet.atlasRow.review': 'Огляд',
  'pet.hatchTitle': 'Виведіть нову домашну тварину за допомогою AI',
  'pet.hatchHint': 'Використовуйте вбудовану навичку hatch-pet у чаті для генерування спрайту у стилі Codex, а потім імпортуйте його сюди.',
  'pet.hatchConcept': 'Концепція домашної тварини (необов\'язково)',
  'pet.hatchConceptPlaceholder': 'напр. крихітна піксельна собака сиба в затишному светрі',
  'pet.hatchCopy': 'Копіювати підказку',
  'pet.hatchCopied': 'Скопійовано!',
  'pet.hatchFoot': 'Після того, як навичка збереже вашу домашну тварину, повернітеся та виберіть «Імпортувати спрайт Codex».',
  'pet.slashPopoverAria': 'Команди скісної риски',
  'pet.slashPopoverTitle': 'Команди',
  'pet.slashPopoverHint': '↑↓ навігація · enter для вибору · esc для закриття',
  'pet.slashPet': 'Перемикання, встановлення або перехід до параметрів домашної тварини.',
  'pet.slashPetWake': 'Розбудити накладку плаваючої домашної тварини.',
  'pet.slashPetTuck': 'Сховати домашну тварину на цей час.',
  'pet.slashHatch': 'Створити домашну тварину Codex через навичку hatch-pet.',
  'pet.slashHatchArg': '<concept>',
  'pet.slashSearch': 'Шукати в інтернеті через команду OD research.',
  'pet.slashSearchArg': '<запит>',
  'pet.codexTitle': 'Недавно виведені',
  'pet.codexSubtitle': 'Домашні тварини, упаковані навичкою hatch-pet, з\'являються тут для встановлення одним натисненням.',
  'pet.codexSubtitleWithDir': 'Сканування {dir} для домашних тварин, упакованих навичкою hatch-pet.',
  'pet.codexEmpty': 'Виведених домашних тварин ще немає. Введіть /hatch у чаті, щоб створити одну.',
  'pet.codexLoading': 'Пошук виведених домашних тварин…',
  'pet.codexRefresh': 'Оновити',
  'pet.codexAdopt': 'Встановити',
  'pet.codexAdopting': 'Встановлення…',
  'pet.communitySync': 'Завантажити домашних тварин спільноти',
  'pet.communitySyncing': 'Завантаження…',
  'pet.communitySyncTitle': 'Синхронізуйте останніх домашних тварин від Codex Pet Share + j20 Hatchery до ~/.codex/pets/.',
  'pet.communitySyncDone': 'Синхронізовано {wrote} нових домашних тварин ({total} всього).',
  'pet.communitySyncFailed': 'Синхронізація не вдалася: {error}',
  'pet.codexBundled': 'Упаковано',
  'pet.codexBundledTitle': 'Поставляється з Open Design — завантаження не потрібне.',

  'settings.notifications': 'Сповіщення',
  'settings.notificationsHint': 'Звук та сповіщення робочого столу при завершенні завдання',
  'settings.notifyCompletionSound': 'Звук завершення',
  'settings.notifyCompletionSoundHint': 'Відтворюється по завершенні черги. За замовчуванням вимкнено.',
  'settings.notifySuccessSound': 'Звук успіху',
  'settings.notifyFailureSound': 'Звук помилки',
  'settings.notifyDesktop': 'Сповіщення робочого столу',
  'settings.notifyDesktopHint': 'Надіслано, коли вікно не має фокусу.',
  'settings.notifyDesktopBlocked': 'Сповіщення заблоковано браузером. Дозволіть їм у налаштуваннях сайту.',
  'settings.notifyDesktopUnsupported': 'Сповіщення робочого столу недоступні в цьому середовищі.',
  'settings.notifyTest': 'Надіслати тест',
  'settings.notifyTestSent': 'Тестове сповіщення надіслано. Якщо банер не з\'явиться, перевірте налаштування сповіщень браузера та системи.',
  'settings.notifyTestFailed': 'Помилка виклику сповіщення. Перевірте налаштування спoвіщень браузера та системи.',
  'settings.notifySoundDing': 'Дзвенить',
  'settings.notifySoundChime': 'Дзвоник',
  'settings.notifySoundTwoToneUp': 'Два тони вгору',
  'settings.notifySoundPluck': 'Щипок',
  'settings.notifySoundBuzz': 'Гудіння',
  'settings.notifySoundTwoToneDown': 'Два тони вниз',
  'settings.notifySoundThud': 'Глухий звук',
  'settings.skills': 'Навички',
  'settings.skillsHint': 'Функціональні навички, які агент може викликати під час задачі',
  'settings.skillsNew': 'Нова навичка',
  'settings.skillsEmpty': 'Виберіть навичку зліва або створіть нову.',
  'settings.skillsEdit': 'Редагувати',
  'settings.skillsDelete': 'Видалити',
  'settings.skillsDeleteConfirm': 'Підтвердити видалення',
  'settings.skillsName': 'Назва',
  'settings.skillsTriggers': 'Тригери (через кому або з нового рядка)',
  'settings.skillsDescription': 'Опис',
  'settings.skillsBody': 'Вміст SKILL.md',
  'settings.skillsCreate': 'Створити',
  'settings.skillsSave': 'Зберегти',
  'settings.skillsSaving': 'Збереження…',
  'settings.skillsFiles': 'Файли',
    'settings.skillsNoFiles': 'У теці цієї навички немає файлів.',
  'settings.skillsNameRequired': 'Ім\'я навички обов\'язкове.',
  'settings.skillsBodyRequired': 'Вміст навички обов\'язковий.',
  'settings.designSystems': 'Дизайн-системи',
  'settings.designSystemsHint': 'Переглядайте та вмикайте доступні дизайн-системи',
  'settings.designSystemsInstalled': 'Встановлено',
  'settings.designSystemsAdd': 'Додати дизайн-систему',
  'settings.designSystemsHiddenCount': '{count} приховано з домашньої галереї',
  'settings.designSystemsShowAll': 'Показати всі',
  'settings.designSystemsShowHidden': 'Показати приховані',
  'settings.designSystemsSource': 'Джерело',
  'settings.designSystemsSourceLocal': 'Локально',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsStructure': 'Структура',
  'settings.designSystemsModeHybrid': 'Гібридна',
  'settings.designSystemsModeNormalized': 'Нормалізована',
  'settings.designSystemsModeVerbatim': 'Без змін',
  'settings.designSystemsCraft': 'Craft',
  'settings.designSystemsCraftColor': 'Колір',
  'settings.designSystemsCraftAccessibility': 'Доступність',
  'settings.designSystemsGithubUrl': 'URL GitHub',
  'settings.designSystemsProjectPath': 'Шлях проєкту',
  'settings.designSystemsImportGithub': 'Імпортувати з GitHub',
  'settings.designSystemsImportProject': 'Імпортувати з проєкту',
  'settings.designSystemsImportedStatus': 'Імпортовано {title}',
  'settings.designSystemsViewImported': 'Переглянути імпортовану дизайн-систему',
  'settings.designSystemsCategory': 'Категорія',
  'settings.designSystemsAllCategories': 'Усі категорії',
  'settings.designSystemsShowInHomeGallery': 'Показувати в домашній галереї',
  'settings.librarySkills': 'Навички',
  'settings.libraryDesignSystems': 'Системи дизайну',
  'settings.librarySearch': 'Пошук...',
  'settings.libraryAll': 'Усі',
  'settings.libraryPreview': 'Попередній перегляд',
  'settings.libraryPreviewClose': 'Закрити',
  'settings.libraryLoading': 'Завантаження...',
  'settings.libraryNoResults': 'Нічого не знайдено за вашим запитом.',
  'settings.libraryEnabled': 'Увімкнено',
  'settings.libraryDisabled': 'Вимкнено',
  'settings.connectorsNavHint': 'Підключення до зовнішніх систем',
  'settings.connectorsHint': 'Керуйте налаштуваннями конекторів і постачальників інструментів для цього пристрою.',
  'settings.connectorsComposioApiKey': 'API-ключ Composio',
  'settings.connectorsSavedTitle': 'Збережено в локальному daemon',
  'settings.connectorsSavedWithTail': 'Збережено · ••••{tail}',
  'settings.connectorsSaved': 'Збережено',
  'settings.connectorsGetApiKey': 'Отримати API-ключ',
  'settings.connectorsReplaceKeyPlaceholder': 'Вставте новий ключ, щоб замінити збережений',
  'settings.connectorsApiKeyPlaceholder': 'Вставте API-ключ Composio',
  'settings.connectorsClear': 'Очистити',
  'settings.connectorsClearConfirmTitle': 'Очистити збережений ключ API Composio?',
  'settings.connectorsClearConfirmBody': 'Видалення ключа від’єднає усі конектори Composio, прив’язані до цього робочого простору. Підключені облікові записи, дозволи OAuth і доступи до інструментів буде вилучено.',
  'settings.connectorsClearConfirmContinue': 'Продовжити',
  'settings.connectorsClearFinalTitle': 'Це від’єднає всі конектори',
  'settings.connectorsClearFinalBody': 'Скасувати неможливо. Після вставлення нового ключа кожну інтеграцію доведеться під’єднувати з нуля.',
  'settings.connectorsClearFinalConfirm': 'Видалити ключ і від’єднати',
  'settings.connectorsClearArming': 'Хвилинку\u2026',
  'settings.connectorsClearCancel': 'Скасувати',
  'settings.connectorsSaveKey': "Зберегти ключ",
  'settings.connectorsSaveKeyTitle': "Надіслати цей ключ локальному демону",
  'settings.connectorsKeySaving': "Збереження…",
  'settings.connectorsKeySaved': "Збережено ✓",
  'settings.connectorsKeyError': "Не вдалося зберегти ключ. Перевірте, чи запущено локальний демон, і спробуйте ще раз.",
  'settings.connectorsHelpSaved': 'Ваш ключ відкриває каталог нижче й залишається в локальному daemon. Вставте новий ключ, щоб замінити його, або очистіть, щоб видалити.',
  'settings.connectorsHelpUnsaved': "Незбережені зміни — натисніть «Зберегти ключ», щоб надіслати ці дані локальному демону і відкрити каталог нижче.",
  'settings.connectorsHelpEmpty': 'Додайте ключ, щоб відкрити каталог нижче. Ключі зберігаються локально в daemon і ніколи не надсилаються через змінні середовища.',
  'settings.connectorsLoadingSavedKey': 'Перевірка збереженого ключа в локальному daemon…',
  'settings.autosaveSaving': "Збереження…",
  'settings.autosaveSaved': "Усі зміни збережено",
  'settings.autosaveError': "Не вдалося зберегти зміни. Можливо, локальний демон офлайн.",
  'settings.libraryToggleLabel': 'Перемкнути',
  // Memory (auto-extracted personalization saved as on-disk markdown)
  'settings.memory': 'Memory',
  'settings.memoryHint': 'Personal facts auto-extracted from chats',
  'settings.memoryDescription': 'Auto-extracted facts about you and your preferences. Saved as Markdown files and folded into every chat.',
  'settings.memoryEnabled': 'Enabled',
  'settings.memoryDisabled': 'Disabled',
  'settings.memoryEnableLabel': 'Enable memory injection',
  'settings.memoryDisabledBanner': 'Memory is currently OFF. Existing facts are preserved on disk but will not be folded into new chats and new turns will not extract anything new.',
  'settings.memoryNew': 'New memory',
  'settings.memoryEdit': 'Edit',
  'settings.memoryDelete': 'Delete',
  'settings.memoryPreview': 'Preview',
  'settings.memoryEmpty': 'No memory yet.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'I prefer dark mode',
  'settings.memoryName': 'Name',
  'settings.memoryDesc': 'One-line description',
  'settings.memoryBody': 'Memory body (Markdown supported)',
  'settings.memoryBodyHint': 'Lead with the rule itself; add Why and How to apply lines.',
  'settings.memoryStartersLabel': 'Need a starting point? Click to fill the form:',
  'settings.memoryStarterUserName': 'My role',
  'settings.memoryStarterUserDesc': 'I am a frontend engineer working on a SaaS design tool',
  'settings.memoryStarterUserBody': '- Role: senior frontend engineer\n- Stack: React, TypeScript, Vite\n- Domain: design / collaboration tools\n- Timezone: GMT+8 (Asia/Shanghai)\n\nWhen to apply: any chat — frame examples around web frontend.',
  'settings.memoryStarterFeedbackName': 'UI preferences',
  'settings.memoryStarterFeedbackDesc': 'Dark mode, large body text, low information density',
  'settings.memoryStarterFeedbackBody': '- Theme: dark by default\n- Body text: ≥ 18px\n- Information density: prefer whitespace, fewer items per screen\n\nWhy: less eye strain during long sessions.\nWhen to apply: whenever you generate UI, web pages, or slides.',
  'settings.memoryStarterProjectName': 'Current project',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — chat-driven design editor',
  'settings.memoryStarterProjectBody': '- Goal: ship the chat-driven editor this quarter\n- Priorities: streaming render, local multimodal, offline-first\n- Stack: Next.js 16, Express daemon, SQLite\n\nWhen to apply: in any conversation about this project.',
  'settings.memorySaveHint': 'Not auto-saved — click Create / Save to apply.',
  'settings.memoryIndexSaveHint': 'Edits to the index are not auto-saved — click Save index to apply.',
  'settings.memoryIndexUnsaved': 'Unsaved changes',
  'settings.memoryFlashCreated': '✓ Memory created',
  'settings.memoryFlashSaved': '✓ Memory saved',
  'settings.memoryFlashDeleted': '✓ Memory deleted',
  'settings.memoryFlashIndexSaved': '✓ Index saved',
  'settings.memoryFlashPathCopied': '✓ Шлях скопійовано',
  'settings.memoryNameLabel': 'Title',
  'settings.memoryTypeLabel': 'Type',
  'settings.memoryDescLabel': 'Description',
  'settings.memoryBodyLabel': 'Content',
  'settings.memoryTypeUser': 'User',
  'settings.memoryTypeFeedback': 'Feedback',
  'settings.memoryTypeProject': 'Project',
  'settings.memoryTypeReference': 'Reference',
  'settings.memoryIndex': 'MEMORY.md (index)',
  'settings.memoryIndexSave': 'Save index',
  'settings.memoryIndexReset': 'Reset',
  'settings.memoryToastChanged': 'Memory updated',
  'settings.memoryToastClickHint': 'Переглянути',
  'settings.memoryAll': 'All',
  'settings.memoryExtractions': 'Extraction history',
  'settings.memoryExtractionsHint': 'Recent LLM-backed extraction attempts. Heuristic regex extraction always runs first; LLM extraction runs in the background after each turn.',
  'settings.memoryExtractionsEmpty': 'No extractions yet. The next chat turn will populate this list.',
  'settings.memoryExtractionsRefresh': 'Refresh',
  'settings.memoryExtractionsRefreshing': 'Refreshing…',
  'settings.memoryExtractionPhaseRunning': 'Running…',
  'settings.memoryExtractionPhaseSuccess': 'Success',
  'settings.memoryExtractionPhaseSkipped': 'Skipped',
  'settings.memoryExtractionPhaseFailed': 'Failed',
  'settings.memoryExtractionSkipNoProvider': 'No API key configured for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'Memory is disabled.',
  'settings.memoryExtractionSkipEmpty': 'Empty user message — nothing to extract.',
  'settings.memoryExtractionSkipNoMatch': 'No regex pattern matched this turn.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'media settings',
  'settings.memoryExtractionProposed': 'proposed',
  'settings.memoryExtractionWritten': 'written',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryNoProviderBannerTitle': 'LLM memory extraction is not running',
  'settings.memoryNoProviderBannerBody': 'No API key found for the memory extractor. Add an OpenAI key under Media providers, or set ANTHROPIC_API_KEY / OPENAI_API_KEY in the environment, to enable LLM-driven extraction. Heuristic regex extraction is still active.',
  'settings.memoryExtractionProviderOverride': 'memory settings',
  'settings.memoryExtractionDelete': 'Delete',
  'settings.memoryExtractionsClear': 'Clear',
  'settings.memoryExtractionsClearTitle': 'Clear all extraction history',
  'settings.libraryInstall': 'Встановити',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Локальний шлях',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Встановити',
  'settings.libraryUninstall': 'Видалити',
  'settings.libraryBuiltIn': 'Вбудований',
  'settings.libraryInstalled': 'Встановлено',
  'notify.successTitle': 'Завдання завершено',
  'notify.failureTitle': 'Завдання не вдалося',
  'notify.successBody': 'Черга завершена.',
  'notify.failureBody': 'Завдання завершилось помилкою.',
  'updater.available': 'Доступне оновлення',
  'updater.availableBody': 'Open Design {version} доступний. Його буде завантажено перед відкриттям інсталятора.',
  'updater.checking': 'Перевірка оновлень',
  'updater.download': 'Завантажити оновлення',
  'updater.downloading': 'Завантаження оновлення',
  'updater.downloadingPercent': 'Завантаження оновлення {percent}%',
  'updater.done': 'Готово',
  'updater.failed': 'Оновлення не вдалося',
  'updater.installerOpenBody': 'Інсталятор відкрито. Open Design закривається, щоб ви могли завершити оновлення.',
  'updater.installerOpened': 'Інсталятор відкрито',
  'updater.later': 'Пізніше',
  'updater.openFailedFallback': 'Не вдалося відкрити інсталятор.',
  'updater.openInstaller': 'Установити оновлення',
  'updater.opening': 'Відкриття інсталятора...',
  'updater.quitButton': 'Закрити Open Design',
  'updater.quitFailedBody': 'Інсталятор відкрито, але Open Design не вдалося закрити. Закрийте Open Design перед заміною застосунку.',
  'updater.quitFailedTitle': 'Не вдалося закрити',
  'updater.quitting': 'Закриття...',
  'updater.ready': 'Оновлення готове',
  'updater.readyGeneric': 'Нова версія готова. Open Design закриється і відкриє інсталятор.',
  'updater.readyVersion': 'Open Design {version} готовий. Open Design закриється і відкриє інсталятор.',
  'updater.upToDate': 'У вас уже встановлено найновішу версію.',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': 'Автоматизація',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Щоденний підсумок конекторів',
  'settings.orbit.lede': 'Збирати активність конекторів за розкладом і публікувати результат як оновлюваний live artifact.',
  'settings.orbit.statusOnTitle': 'Щоденні запуски за розкладом увімкнені',
  'settings.orbit.statusOffTitle': 'Щоденні запуски за розкладом вимкнені',
  'settings.orbit.statusActive': 'Активно',
  'settings.orbit.statusOff': 'Вимкнено',
  'settings.orbit.runTitle': 'Запустити Orbit і відкрити живу розмову',
  'settings.orbit.running': 'Виконується…',
  'settings.orbit.runOpen': 'Запустити зараз',
  'settings.orbit.dailySummaryTitle': 'Щоденний підсумок',
  'settings.orbit.dailySummarySub': 'Виконується раз на день у запланований локальний час.',
  'settings.orbit.on': 'Увімкнено',
  'settings.orbit.off': 'Вимкнено',
  'settings.orbit.runTimeTitle': 'Час запуску',
  'settings.orbit.runTimeSub': 'За замовчуванням 08:00. Збережіть, щоб застосувати розклад daemon.',
  'settings.orbit.runTimeAria': 'Час щоденного запуску Orbit',
  'settings.orbit.nextRun': 'Наступний запуск',
  'settings.orbit.nextRunScheduledAfterSave': 'Заплановано після збереження',
  'settings.orbit.schedule': 'Розклад',
  'settings.orbit.pausedManualOnly': 'Призупинено — лише ручні запуски',
  'settings.orbit.templateTitle': 'Шаблон prompt',
  'settings.orbit.templateMissing': 'Шаблон {id} не встановлено.',
  'settings.orbit.templateMissingOption': '{id} (немає)',
  'settings.orbit.templateMissingInstall': 'Установіть skill Orbit, щоб спрямовувати prompt.',
  'settings.orbit.templateMissingPickAnother': 'Виберіть інший шаблон у списку.',
  'settings.orbit.templateResetTitle': 'Скинути до {id}',
  'settings.orbit.templateReset': 'Скинути',
  'settings.orbit.templateHelp': 'Спрямовуйте Orbit за допомогою skill — приклад prompt вибраного шаблону додається до кожного запуску Orbit, щоб підсумки мали форму цього шаблону.',
  'settings.orbit.templateAria': 'Шаблон prompt Orbit',
  'settings.orbit.templatesLoading': 'Завантаження шаблонів…',
  'settings.orbit.templatesOptgroup': 'Шаблони skills Orbit',
  'settings.orbit.lastRun': 'Останній запуск',
  'settings.orbit.triggerManual': 'Вручну',
  'settings.orbit.triggerScheduled': 'За розкладом',
  'settings.orbit.meterAria': '{succeeded} успішно, {skipped} пропущено, {failed} з помилкою з {checked} перевірено',
  'settings.orbit.countChecked': 'Перевірено',
  'settings.orbit.countSucceeded': 'Успішно',
  'settings.orbit.countSkipped': 'Пропущено',
  'settings.orbit.countFailed': 'Помилка',
  'settings.orbit.runError': 'Не вдалося запустити Orbit. Переконайтеся, що локальний daemon працює, а конектори налаштовані.',
  'settings.orbit.gateAriaLabel': "Для роботи Orbit потрібні конектори",
  'settings.orbit.gateEyebrow': "Потрібне налаштування",
  'settings.orbit.gateTitle': "Підключіть інструмент, щоб запустити Orbit",
  'settings.orbit.gateBody': "Orbit узагальнює активність ваших конекторів. Ви ще нічого не підключили — додайте хоча б одну інтеграцію, щоб Orbit мав про що повідомляти.",
  'settings.orbit.gateBodyNoKey': "Orbit узагальнює активність конекторів, а конектори працюють через Composio. Додайте ключ API Composio у розділі «Конектори», щоб відкрити каталог і обрати першу інтеграцію.",
  'settings.orbit.gateAction': "Відкрити конектори",
  'settings.orbit.gateActionNoKey': "Налаштувати Composio",
  'settings.orbit.gateLoading': "Перевірка конекторів…",
  'settings.orbit.controlsLockedBadge': "Заблоковано",
  'settings.orbit.controlsLockedHint': "Підключіть інструмент, щоб розблокувати розклад і шаблон Orbit.",
  'settings.orbit.artifactKickerLive': 'live artifact',
  'settings.orbit.artifactKickerLegacy': 'Застарілий підсумок',
  'settings.orbit.artifactTitle': 'Щоденний підсумок активності Orbit',
  'settings.orbit.artifactMetaLive': 'Оновлюваний HTML-артефакт, створений з активності конекторів.',
  'settings.orbit.artifactMetaLegacy': 'Створено до ввімкнення підтримки live artifact — запустіть Orbit знову, щоб опублікувати один.',
  'settings.orbit.copyMarkdownTitle': 'Скопіювати підсумок Markdown у буфер',
  'settings.orbit.copied': 'Скопійовано',
  'settings.orbit.copy': 'Копіювати',
  'settings.orbit.openArtifact': 'Відкрити артефакт',
  'settings.orbit.sourceMarkdown': 'Вихідний Markdown',
  'liveArtifact.viewer.tabPreview': 'Попередній перегляд',
  'liveArtifact.viewer.tabCode': 'Код',
  'liveArtifact.viewer.tabData': 'Дані',
  'liveArtifact.viewer.tabRefreshHistory': 'Історія оновлень',
  'liveArtifact.viewer.dataEmpty': 'Кеш data.json недоступний.',
  'liveArtifact.viewer.code.templateHeading': 'HTML шаблону',
  'liveArtifact.viewer.code.renderedHeading': 'Згенерований HTML',
  'liveArtifact.viewer.code.templateHelp': 'Редагований шаблон, що використовується з data.json для створення попереднього перегляду.',
  'liveArtifact.viewer.code.renderedHelp': 'Згенерований index.html, який зараз завантажує попередній перегляд.',
  'liveArtifact.viewer.code.variantAria': 'Варіант коду',
  'liveArtifact.viewer.code.variantTemplate': 'Шаблон',
  'liveArtifact.viewer.code.variantRendered': 'Згенеровано',
  'liveArtifact.viewer.code.loading': 'Завантаження коду…',
  'liveArtifact.viewer.code.unavailable': 'Код ще недоступний.',
  'liveArtifact.viewer.code.empty': 'Цей файл коду порожній.',

  // Diagnostics export
  'diagnostics.exportTitle': 'Експорт діагностики',
  'diagnostics.exportButton': 'Експорт діагностики',
  'diagnostics.exportHint': 'Збирає останні журнали застосунку та інформацію про пристрій у zip для надсилання команді.',
  'diagnostics.exporting': 'Експортування…',
  'diagnostics.exportSuccess': 'Діагностику збережено: {path}',
  'diagnostics.exportFailed': 'Не вдалося експортувати діагностику: {message}',
  'generationPreview.title': 'Генерація…',
  'generationPreview.failedTitle': 'Помилка генерації',
  'generationPreview.failedFallback': 'Щось пішло не так. Спробуйте ще раз.',
  'generationPreview.footnote': 'Зазвичай триває 2–5 хвилин',
  'generationPreview.stepUnderstand': 'Аналіз вимог',
  'generationPreview.stepGenerate': 'Створення сторінки',
  'generationPreview.stepPrepare': 'Підготовка попереднього перегляду',
  'generationPreview.elapsed': 'Минуло {elapsed}',
  'generationPreview.estimate': 'Зазвичай 2–5 хв',
  'generationPreview.progressAria': 'Прогрес генерації: {percent}%',
  'generationPreview.retry': 'Повторити',
  'generationPreview.awaitingTitle': 'Очікування вашої відповіді',
  'generationPreview.awaitingLead': 'Дайте відповідь на кілька запитань у чаті, щоб продовжити.',
  'generationPreview.stoppedTitle': 'Генерацію призупинено',
  'generationPreview.stoppedLead': 'Продовжте решту кроків у чаті ліворуч.',
};
